/* =========================================================================
 * SCRIPT 1 — Rewards page redesign ("Ways To Earn Points" widget)
 * ========================================================================= */
(function () {
  function isRewardsPage() {
    var path = window.location.pathname.replace(/\/$/, '');

    if (path === '/pages/rewards') {
      return true;
    }

    var params = new URLSearchParams(window.location.search);
    var previewPath = params.get('previewPath');

    if (previewPath && previewPath.replace(/\/$/, '') === '/pages/rewards') {
      return true;
    }

    return window.location.href.indexOf('previewPath=%2Fpages%2Frewards') !== -1;
  }

  if (!isRewardsPage()) {
    return;
  }

  var settings = {
    mainColor: '#09152B',
    textColor: '#181F2E',
    accentColor: '#ECC643',
    borderColor: '#000000',
    backgroundColor: '#FFFFFF',
    loggedInBg: '#F5EFE3',
    heading: 'Ways To Earn Points',
    subheading: 'Every action that helps the Sima community earns you points.',
    icons: {
      purchase: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/shopping-cart_4501806_2_1_763e5a02-aa05-493d-a550-ebff937a733c.svg?v=1784119371',
      join: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/balloon_13941477_1_5cab6100-7da0-4759-af52-f138b612c72c.svg?v=1784119377',
      subscription: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/sync_4074689_1_5cd3f1f5-599b-40c0-98aa-5bd98e125750.svg?v=1784119339',
      review: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/review_14990762_1_6cc4580c-2948-44f0-8125-76c670df748a.svg?v=1784119345',
      photo: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/camera_3679561_1_9c7b1afc-8903-4cef-9d7c-5421574889cf.svg?v=1784119348',
      video: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/video-player_10045692_1_c2240446-51af-4feb-a6ab-05d266572407.svg?v=1784119351',
      birthday: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/cake_16777864_1_bc07d895-f0a2-4c24-a13d-fed74920fc94.svg?v=1784119353',
      social: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/social_14068611_1_1d5394ed-61c0-4c16-8c43-cbdcd01b13ef.svg?v=1784119355',
      facebook: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2242%22%20height%3D%2242%22%20viewBox%3D%220%200%2042%2042%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M38.0631%209.84426C38.0631%206.58487%2035.4162%203.93799%2032.1568%203.93799H9.84426C6.58487%203.93799%203.93799%206.58487%203.93799%209.84426V32.1568C3.93799%2035.4162%206.58487%2038.0631%209.84426%2038.0631H32.1568C35.4162%2038.0631%2038.0631%2035.4162%2038.0631%2032.1568V9.84426ZM36.7506%209.84426V32.1568C36.7506%2034.6922%2034.6922%2036.7506%2032.1568%2036.7506H9.84426C7.30894%2036.7506%205.25049%2034.6922%205.25049%2032.1568V9.84426C5.25049%207.30894%207.30894%205.25049%209.84426%205.25049H32.1568C34.6922%205.25049%2036.7506%207.30894%2036.7506%209.84426Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.0318%2037.4065V24.9377H15.0942C14.732%2024.9377%2014.438%2024.6437%2014.438%2024.2814V19.6877C14.438%2019.3254%2014.732%2019.0314%2015.0942%2019.0314H19.0318V15.0939C19.0318%2011.8343%2021.6784%209.18762%2024.938%209.18762H30.8443C31.2065%209.18762%2031.5005%209.48162%2031.5005%209.84387V14.4376C31.5005%2014.7999%2031.2065%2015.0939%2030.8443%2015.0939H27.563C26.4763%2015.0939%2025.5943%2015.9759%2025.5943%2017.0626L25.5332%2019.0314H30.8443C31.0346%2019.0314%2031.2157%2019.1141%2031.3398%2019.2578C31.4644%2019.4015%2031.5209%2019.5918%2031.494%2019.7802L30.8377%2024.374C30.7918%2024.6975%2030.5149%2024.9377%2030.188%2024.9377H25.5943V37.4065H24.2818V24.2814C24.2818%2023.9192%2024.5758%2023.6252%2024.938%2023.6252H29.6191L30.0876%2020.3439H24.856C24.6781%2020.3439%2024.5082%2020.2717%2024.3848%2020.1444C24.2614%2020.0171%2024.1945%2019.8445%2024.1997%2019.6673C24.1997%2019.6673%2024.2818%2017.0515%2024.2818%2017.0541C24.2864%2015.2468%2025.7551%2013.7814%2027.563%2013.7814H30.188V10.5001H24.938C22.4029%2010.5001%2020.3443%2012.5588%2020.3443%2015.0939V19.6877C20.3443%2020.0499%2020.0503%2020.3439%2019.688%2020.3439H15.7505V23.6252H19.688C20.0503%2023.6252%2020.3443%2023.9192%2020.3443%2024.2814V37.4065H19.0318Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%3C%2Fsvg%3E',
      tiktok: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2242%22%20height%3D%2242%22%20viewBox%3D%220%200%2042%2042%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url%28%23clip0_36_660%29%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M17.448%2035.7328C14.9542%2035.7328%2012.6082%2034.7648%2010.8363%2032.9929C9.07261%2031.2292%208.09644%2028.8832%208.09644%2026.3812C8.09644%2023.8875%209.07261%2021.5414%2010.8363%2019.7695C12.6%2018.0058%2014.946%2017.0296%2017.448%2017.0296C17.9156%2017.0296%2018.3914%2017.0625%2018.8507%2017.1363C19.1542%2017.1855%2019.3757%2017.4398%2019.3757%2017.7433V22.4109C19.3757%2022.6078%2019.2773%2022.7964%2019.1214%2022.9113C18.9574%2023.0261%2018.7523%2023.0589%2018.5636%2022.9933C18.2027%2022.8703%2017.8253%2022.8128%2017.448%2022.8128C15.4875%2022.8128%2013.8878%2024.4125%2013.8878%2026.373C13.8878%2028.3335%2015.4875%2029.9332%2017.448%2029.9332C17.8253%2029.9332%2018.2027%2029.8757%2018.5636%2029.7527C20.0156%2029.2687%2020.9917%2027.9234%2021%2026.3894V6.86597C21%206.52964%2021.2789%206.25073%2021.6152%206.25073H26.1761C26.5125%206.25073%2026.7914%206.52964%2026.7914%206.86597C26.7914%2010.4425%2029.7035%2013.3464%2033.28%2013.3464C33.6164%2013.3464%2033.8953%2013.6253%2033.8953%2013.9617V18.539C33.8953%2018.8753%2033.6164%2019.1542%2033.28%2019.1542C31.623%2019.1542%2030.0152%2018.8261%2028.4976%2018.1863C27.907%2017.932%2027.3328%2017.6367%2026.7914%2017.3003V26.4304C26.7832%2028.916%2025.807%2031.2457%2024.0515%2033.0011C22.6242%2034.4285%2020.8277%2035.339%2018.8507%2035.6343C18.3914%2035.7%2017.9156%2035.7328%2017.448%2035.7328ZM17.448%2018.2765C15.2824%2018.2765%2013.2398%2019.1214%2011.714%2020.6554C10.18%2022.1894%209.33511%2024.2238%209.33511%2026.3894C9.33511%2028.555%2010.18%2030.5976%2011.714%2032.1234C13.248%2033.6574%2015.2824%2034.5023%2017.448%2034.5023C17.8582%2034.5023%2018.2683%2034.4695%2018.6703%2034.4121C20.3847%2034.1578%2021.9515%2033.3621%2023.1902%2032.1234C24.716%2030.5976%2025.5609%2028.5714%2025.5691%2026.4222V16.1191C25.5691%2015.8812%2025.7003%2015.6679%2025.9136%2015.5695C26.1269%2015.4628%2026.373%2015.4875%2026.5617%2015.6351C27.3082%2016.2093%2028.1203%2016.6851%2028.9898%2017.0542C30.1628%2017.5546%2031.4015%2017.8335%2032.673%2017.9074V14.5769C28.9078%2014.2816%2025.8972%2011.2628%2025.5937%207.50581H22.2304V26.414C22.2222%2028.473%2020.9015%2030.2941%2018.9492%2030.9421C18.457%2031.1062%2017.9566%2031.1882%2017.4398%2031.1882C14.7984%2031.1882%2012.6492%2029.039%2012.6492%2026.3976C12.6492%2023.7562%2014.7984%2021.607%2017.4398%2021.607C17.6777%2021.607%2017.9074%2021.6234%2018.1371%2021.6562V18.3093C17.9156%2018.2847%2017.6777%2018.2765%2017.448%2018.2765Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M1.23047%207.87493V38.9238C1.23047%2039.9409%202.05898%2040.7695%203.07617%2040.7695H38.9238C39.941%2040.7695%2040.7695%2039.9409%2040.7695%2038.9238V30.089C40.7695%2029.7527%2041.0484%2029.4738%2041.3848%2029.4738C41.7211%2029.4738%2042%2029.7527%2042%2030.089V38.9238C42%2040.6218%2040.6219%2041.9999%2038.9238%2041.9999H3.07617C1.37812%2041.9999%200%2040.6218%200%2038.9238V7.87493C0%207.5386%200.270703%207.2679%200.598828%207.2597C0.951563%207.25149%201.23047%207.5304%201.23047%207.87493Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%203.79805V3.07617C0%201.37812%201.37812%200%203.07617%200H38.9238C40.6219%200%2042%201.37812%2042%203.07617V26.0285C42%2026.3648%2041.7211%2026.6437%2041.3848%2026.6437C41.0484%2026.6437%2040.7695%2026.3648%2040.7695%2026.0285V3.07617C40.7695%202.05898%2039.941%201.23047%2038.9238%201.23047H3.07617C2.05898%201.23047%201.23047%202.05898%201.23047%203.07617V3.79805C1.23047%204.13438%200.951562%204.41328%200.615234%204.41328C0.278906%204.41328%200%204.13438%200%203.79805Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_36_660%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2242%22%20height%3D%2242%22%20fill%3D%22white%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E'
    }
  };

  // Types whose native Yotpo description text gets swapped for a shorter label.
  var descriptionOverridesByType = {
    photo: 'Add a photo to review',
    video: 'Add a video to review',
    review: 'Leave a review',
    subscription: 'Make a subscription purchase',
    instagram: 'Follow on Instagram',
    facebook: 'Follow on Facebook',
    tiktok: 'Follow on TikTok'
  };

  // Icon overrides that differ from the default settings.icons[type] lookup.
  var iconOverridesByType = {
    facebook: settings.icons.facebook,
    tiktok: settings.icons.tiktok,
    instagram: settings.icons.social
  };

  function injectStyles() {
    var oldStyle = document.getElementById('cw-yotpo-ways-redesign-css');

    if (oldStyle) {
      oldStyle.remove();
    }

    var style = document.createElement('style');
    style.id = 'cw-yotpo-ways-redesign-css';

    style.textContent = `
      body.cw-yotpo-ways-ready .cw-yotpo-hidden {
        display: none !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-loyalty-page,
      body.cw-yotpo-ways-ready .yotpo-loyalty-page-container,
      body.cw-yotpo-ways-ready .yotpo-widget-campaign-widget,
      body.cw-yotpo-ways-ready .yotpo-widget-campaign-widget-layout {
        width: 100% !important;
        background: ${settings.backgroundColor} !important;
        overflow: visible !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-loyalty-page {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-instance-container:has(.yotpo-widget-my-rewards-widget) {
        width: 100% !important;
        order: 1 !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-instance-container:has(.yotpo-widget-campaign-widget) {
        width: 100% !important;
        order: 2 !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget {
        width: 100% !important;
        max-width: 1500px !important;
        min-height: 302px !important;
        margin: 0 auto !important;
        padding: 60px 100px !important;
        background: linear-gradient(90deg, rgba(245, 239, 227, 0) 0%, ${settings.loggedInBg} 50%, rgba(245, 239, 227, 0) 100%) !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-widget-clear,
      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-background,
      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-logged-in-view {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        background: transparent !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 24px !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-headline {
        display: none !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .cw-my-rewards-headline {
        width: 100% !important;
        max-width: 561px !important;
        min-height: 46px !important;
        margin: 0 !important;
        color: ${settings.textColor} !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 42px !important;
        font-weight: 600 !important;
        line-height: 58.8px !important;
        text-align: center !important;
        text-transform: capitalize !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description {
        margin: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description .yotpo-inner-text,
      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description-points-balance .yotpo-inner-text,
      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description-tier-status .yotpo-inner-text {
        color: #E7B300 !important;
        font-family: "Open Sans", sans-serif !important;
        font-size: 24px !important;
        font-weight: 600 !important;
        line-height: 33.6px !important;
        text-align: center !important;
        text-transform: capitalize !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-vertical-divider {
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        border: 0 !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-vertical-divider::before {
        content: "|" !important;
        color: #E7B300 !important;
        font-family: "Open Sans", sans-serif !important;
        font-size: 24px !important;
        font-weight: 600 !important;
        line-height: 33.6px !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-action-buttons-tile {
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 24px !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-action-button {
        width: 242px !important;
        height: 60px !important;
        min-width: 242px !important;
        min-height: 60px !important;
        margin: 0 !important;
        padding: 16px 10px !important;
        border-radius: 3px !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        line-height: 22.4px !important;
        text-transform: uppercase !important;
        text-align: center !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-primary-button {
        background: ${settings.mainColor} !important;
        border: 1px solid ${settings.mainColor} !important;
        color: #FFFFFF !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-secondary-button {
        background: transparent !important;
        border: 1px solid ${settings.mainColor} !important;
        color: ${settings.mainColor} !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-campaign-widget-container {
        width: 100% !important;
        max-width: 1500px !important;
        margin: 0 auto !important;
        padding: 100px 20px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        gap: 60px !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .cw-yotpo-ways-header {
        width: 100% !important;
        max-width: 850px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        gap: 24px !important;
      }

      body.cw-yotpo-ways-ready .yotpo-container-headline {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        color: ${settings.mainColor} !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 42px !important;
        font-weight: 600 !important;
        line-height: 58.8px !important;
        text-align: center !important;
        text-transform: capitalize !important;
      }

      body.cw-yotpo-ways-ready .cw-yotpo-ways-subheading {
        width: 100% !important;
        margin: 0 !important;
        color: ${settings.textColor} !important;
        font-family: "Open Sans", sans-serif !important;
        font-size: 18px !important;
        font-weight: 400 !important;
        line-height: 25.2px !important;
        text-align: center !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper {
        width: 1074px !important;
        max-width: 1074px !important;
        margin: 0 auto !important;
        display: grid !important;
        grid-template-columns: repeat(3, 347px) !important;
        justify-content: center !important;
        align-items: stretch !important;
        gap: 16px !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile {
        width: 347px !important;
        max-width: 347px !important;
        height: 189px !important;
        min-height: 189px !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 1px solid ${settings.borderColor} !important;
        border-radius: 15.99px !important;
        background: ${settings.backgroundColor} !important;
        position: relative !important;
        overflow: hidden !important;
        isolation: isolate !important;
        box-sizing: border-box !important;
        cursor: pointer !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="purchase"] {
        order: 1 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="join"] {
        order: 2 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="subscription"] {
        order: 3 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="review"] {
        order: 4 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="photo"] {
        order: 5 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="video"] {
        order: 6 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="birthday"] {
        order: 7 !important;
        grid-column: 1 !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="instagram"] {
        order: 8 !important;
        grid-column: 2 !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="facebook"] {
        order: 9 !important;
        grid-column: 3 !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="tiktok"] {
        order: 10 !important;
        grid-column: 2 !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile-group,
      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-campaign-switcher-wrapper,
      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile-wrapper {
        width: 100% !important;
        height: 100% !important;
        min-height: inherit !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile {
        width: 100% !important;
        height: 100% !important;
        min-height: 189px !important;
        padding: 24px !important;
        background: transparent !important;
        border: 0 !important;
        border-radius: 15.99px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 15.99px !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-widget-campaign-widget-icon-container {
        width: 64px !important;
        height: 64px !important;
        margin: 0 !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
        background-size: contain !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-widget-campaign-widget-icon-container svg {
        opacity: 0 !important;
        visibility: hidden !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-headline-container {
        width: 100% !important;
        margin: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 15.99px !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-headline-center-element {
        width: 100% !important;
        margin: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-title-text {
        width: auto !important;
        max-width: 100% !important;
        margin: 0 !important;
        color: ${settings.mainColor} !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 20px !important;
        font-weight: 600 !important;
        line-height: 24px !important;
        text-align: center !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-description-text {
        width: 100% !important;
        margin: 0 !important;
        color: ${settings.textColor} !important;
        font-family: "Open Sans", sans-serif !important;
        font-size: 16px !important;
        font-weight: 400 !important;
        line-height: 22.4px !important;
        text-align: center !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-completed-icon {
        width: 18px !important;
        min-width: 18px !important;
        height: 18px !important;
        margin: 0 !important;
        color: ${settings.mainColor} !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
      }


      body.cw-yotpo-ways-ready .cw-yotpo-redemption-source-hidden {
        display: none !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__balance {
        margin: -32px 0 0 !important;
        color: ${settings.mainColor} !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 18px !important;
        font-weight: 600 !important;
        line-height: 25.2px !important;
        text-align: center !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__balance-value {
        color: ${settings.accentColor} !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__card-action {
        width: 100% !important;
        margin-top: auto !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__native-redeem {
        width: 100% !important;
        min-width: 0 !important;
        height: 48px !important;
        min-height: 48px !important;
        margin: 0 !important;
        padding: 12px 16px !important;
        border: 1px solid ${settings.mainColor} !important;
        border-radius: 3px !important;
        background: ${settings.mainColor} !important;
        color: #FFFFFF !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        line-height: 19.6px !important;
        text-align: center !important;
        text-transform: uppercase !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__native-redeem:disabled,
      body.cw-yotpo-ways-ready .cw-points-can-become__native-redeem[disabled],
      body.cw-yotpo-ways-ready .cw-points-can-become__native-redeem[aria-disabled="true"] {
        border-color: #9B9B9B !important;
        background: #9B9B9B !important;
        color: #FFFFFF !important;
        cursor: not-allowed !important;
        opacity: 1 !important;
      }
    
      @media(min-width: 750px){
      #cw-yotpo-redemption-rendered .cw-redemption__description{
      white-space: nowrap !important;
      position: relative;
      right: 12px;
      }
    .cw-redemption__description{
     white-space: nowrap !important;
      position: relative;
      right: 12px;
    }
 
.cw-redemption__points{position: relative !important; top: 10px !important;}


    #cw-yotpo-redemption-rendered .cw-redemption__card{align-items: start !important;}
      }
      
      @media screen and (max-width: 749px) {
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget {
          max-width: 390px !important;
          min-height: auto !important;
          padding: 45px 20px !important;
          background: linear-gradient(270deg, rgba(245, 239, 227, 0) 0%, ${settings.loggedInBg} 50%, rgba(245, 239, 227, 0) 100%) !important;
          overflow: hidden !important;
        }
       

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-widget-clear,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-background,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-logged-in-view {
          max-width: 350px !important;
          gap: 24px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .cw-my-rewards-headline {
          min-height: 46px !important;
          font-size: 26px !important;
          line-height: 36.4px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description .yotpo-inner-text,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description-points-balance .yotpo-inner-text,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description-tier-status .yotpo-inner-text,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-vertical-divider::before {
          font-size: 20px !important;
          line-height: 28px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-action-buttons-tile {
          width: 342px !important;
          gap: 22px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-action-button {
          width: 160px !important;
          min-width: 160px !important;
          height: 52px !important;
          min-height: 52px !important;
          padding: 16px 10px !important;
          font-size: 13px !important;
          line-height: 18.2px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-campaign-widget-container {
          max-width: 390px !important;
          padding: 45px 20px !important;
          gap: 35px !important;
        }

        body.cw-yotpo-ways-ready .cw-yotpo-ways-header {
          max-width: 356px !important;
          gap: 24px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-container-headline {
          font-size: 26px !important;
          line-height: 36.4px !important;
        }

        body.cw-yotpo-ways-ready .cw-yotpo-ways-subheading {
          font-size: 18px !important;
          line-height: 25.2px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper {
          width: 100% !important;
          max-width: none !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          align-items: stretch !important;
          gap: 16px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile {
          width: 100% !important;
          max-width: none !important;
          height: auto !important;
          min-height: 154px !important;
          border-radius: 15.99px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="birthday"],
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="instagram"],
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="facebook"],
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="tiktok"] {
          grid-column: auto !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile-group,
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-campaign-switcher-wrapper,
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile-wrapper {
          height: auto !important;
          min-height: 100% !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile {
          height: auto !important;
          min-height: 154px !important;
          padding: 15px !important;
          justify-content: center !important;
          gap: 15.99px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-widget-campaign-widget-icon-container {
          width: 42px !important;
          height: 42px !important;
          min-width: 42px !important;
          min-height: 42px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-headline-container {
          height: auto !important;
          min-height: 0 !important;
          gap: 15.99px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-headline-center-element {
          height: auto !important;
          min-height: 0 !important;
          gap: 8px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-title-text {
          width: 100% !important;
          min-height: 0 !important;
          font-size: 16px !important;
          line-height: 19.2px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-description-text {
          width: 100% !important;
          min-height: 0 !important;
          font-size: 13px !important;
          line-height: 18.2px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function findRedemptionInstance() {
    var instances = Array.from(
      document.querySelectorAll('.yotpo-widget-instance-container')
    );

    return instances.find(function (instance) {
      if (
        instance.querySelector('.yotpo-widget-campaign-widget') ||
        instance.querySelector('.yotpo-widget-my-rewards-widget') ||
        instance.closest('.cw-points-can-become')
      ) {
        return false;
      }

      var buttons = Array.from(instance.querySelectorAll('button, a'));
      var hasRedeemButton = buttons.some(function (button) {
        return button.textContent.trim().toLowerCase().indexOf('redeem') !== -1;
      });

      var text = instance.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      var hasPointsContent = /\b\d+\s*points?\b/.test(text);

      return hasRedeemButton && hasPointsContent;
    }) || null;
  }

  function getWidgets() {
    return {
      campaign: document.querySelector('.yotpo-widget-campaign-widget'),
      rewards: document.querySelector('.yotpo-widget-my-rewards-widget'),
      redemptionInstance: findRedemptionInstance()
    };
  }

  function isolateYotpoInstances() {
    var loyaltyPage = document.querySelector('.yotpo-widget-loyalty-page');

    if (!loyaltyPage) {
      return;
    }

    loyaltyPage.querySelectorAll('.yotpo-widget-instance-container').forEach(function (instance) {
      var hasCampaign = !!instance.querySelector('.yotpo-widget-campaign-widget');
      var hasRewards = !!instance.querySelector('.yotpo-widget-my-rewards-widget');

      instance.classList.toggle('cw-yotpo-hidden', !(hasCampaign || hasRewards));
    });
  }

  function prepareHeader(campaignWidget) {
    var container = campaignWidget.querySelector('.yotpo-widget-campaign-widget-container');
    var headline = campaignWidget.querySelector('.yotpo-container-headline');

    if (!container || !headline) {
      return;
    }

    headline.textContent = settings.heading;

    var header = headline.closest('.cw-yotpo-ways-header');

    if (!header) {
      header = document.createElement('div');
      header.className = 'cw-yotpo-ways-header';

      container.insertBefore(header, headline);
      header.appendChild(headline);
    }

    var subheading = header.querySelector('.cw-yotpo-ways-subheading');

    if (!subheading) {
      subheading = document.createElement('div');
      subheading.className = 'cw-yotpo-ways-subheading';
      header.appendChild(subheading);
    }

    subheading.textContent = settings.subheading;
  }

  function getTileType(tile) {
    var text = tile.textContent.toLowerCase();
    var description = tile.querySelector('.yotpo-description-text');
    var descriptionText = description ? description.textContent.toLowerCase() : '';
    var html = tile.innerHTML.toLowerCase();

    if (descriptionText.indexOf('subscription') !== -1 || text.indexOf('subscription') !== -1) return 'subscription';
    if (descriptionText.indexOf('birthday') !== -1 || html.indexOf('birthdaycampaign') !== -1) return 'birthday';
    if (descriptionText.indexOf('video') !== -1 || html.indexOf('videocampaign') !== -1) return 'video';
    if (descriptionText.indexOf('photo') !== -1 || descriptionText.indexOf('image') !== -1 || html.indexOf('imagecampaign') !== -1) return 'photo';
    if (descriptionText.indexOf('leave a review') !== -1 || html.indexOf('yotporeviewcampaign') !== -1) return 'review';
    if (descriptionText.indexOf('instagram') !== -1 || html.indexOf('instagram') !== -1) return 'instagram';
    if (descriptionText.indexOf('tiktok') !== -1 || text.indexOf('tiktok') !== -1) return 'tiktok';
    if (descriptionText.indexOf('facebook') !== -1 || text.indexOf('facebook') !== -1) return 'facebook';
    if (descriptionText.indexOf('join') !== -1 || html.indexOf('createaccountcampaign') !== -1) return 'join';
    if (descriptionText.indexOf('purchase') !== -1 || text.indexOf('purchase') !== -1) return 'purchase';

    return 'social';
  }

  function getIconUrl(type) {
    return iconOverridesByType[type] || settings.icons[type] || settings.icons.social;
  }

  function updateTileDescription(tile, type) {
    var description = tile.querySelector('.yotpo-description-text');
    var replacement = descriptionOverridesByType[type];

    if (description && replacement) {
      description.textContent = replacement;
    }
  }

  function replaceIcon(tile, type) {
    var iconContainer = tile.querySelector('.yotpo-widget-campaign-widget-icon-container');

    if (iconContainer) {
      iconContainer.style.backgroundImage = 'url("' + getIconUrl(type) + '")';
    }
  }

  function prepareCards(campaignWidget) {
    var tiles = campaignWidget.querySelectorAll('.campaigns-wrapper .yotpo-outer-tile');

    tiles.forEach(function (tile) {
      var type = getTileType(tile);

      tile.dataset.cwType = type;

      updateTileDescription(tile, type);
      replaceIcon(tile, type);
    });
  }

  function prepareRewardsWidget(rewardsWidget) {
    if (!rewardsWidget) {
      return;
    }

    var loggedInView = rewardsWidget.querySelector('.yotpo-logged-in-view');

    if (!loggedInView || loggedInView.getClientRects().length === 0) {
      return;
    }

    var loggedInStyles = window.getComputedStyle(loggedInView);

    if (
      loggedInStyles.display === 'none' ||
      loggedInStyles.visibility === 'hidden' ||
      loggedInStyles.opacity === '0'
    ) {
      return;
    }

    var nativeHeadline = rewardsWidget.querySelector('.yotpo-headline');

    if (nativeHeadline) {
      nativeHeadline.style.display = 'none';
    }

    var customHeadline = rewardsWidget.querySelector('.cw-my-rewards-headline');

    if (!customHeadline) {
      customHeadline = document.createElement('div');
      customHeadline.className = 'cw-my-rewards-headline';
      loggedInView.insertBefore(customHeadline, loggedInView.firstChild);
    }

    customHeadline.textContent = 'Hey there!';

    var primaryButton = rewardsWidget.querySelector('.yotpo-primary-button');
    var secondaryButton = rewardsWidget.querySelector('.yotpo-secondary-button');

    if (primaryButton) {
      primaryButton.textContent = 'Redeem my points';
    }

    if (secondaryButton) {
      secondaryButton.textContent = 'Rewards history';
    }

    var rewardsStepsSection = document.getElementById(
      'cw-rewards-steps-template--22782640718132__cw_three_steps_kf9pTG'
    );

    if (!rewardsStepsSection) {
      return;
    }

    var rewardsStepsInner = rewardsStepsSection.querySelector(
      '.cw-rewards-steps__inner'
    );

    if (
      !rewardsStepsInner ||
      rewardsStepsInner.dataset.cwLoggedInContent === 'true'
    ) {
      return;
    }

    rewardsStepsInner.innerHTML = '';
    rewardsStepsInner.appendChild(rewardsWidget);
    rewardsStepsInner.dataset.cwLoggedInContent = 'true';

    rewardsWidget.style.setProperty('background', 'transparent', 'important');
    rewardsWidget.style.setProperty('max-width', 'none', 'important');
    rewardsWidget.style.setProperty('min-height', 'auto', 'important');
    rewardsWidget.style.setProperty('padding', '0', 'important');
  }

  function getRewardTileFromButton(button, root) {
    var node = button;

    while (node && node !== root) {
      var text = node.textContent.replace(/\s+/g, ' ').trim().toLowerCase();

      if (
        /\b\d+\s*points?\b/.test(text) &&
        text.indexOf('redeem') !== -1
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return button.parentElement;
  }

  function getRewardData(tile, button) {
    var normalizedText = tile.textContent.replace(/\s+/g, ' ').trim();
    var pointsMatch = normalizedText.match(/\b\d[\d,]*\s*points?\b/i);
    var moneyMatch = normalizedText.match(/\$\s*\d+(?:\.\d{1,2})?\s*(?:off)?/i);

    var title = moneyMatch ? moneyMatch[0].replace(/\s+/g, ' ').trim() : '';
    var points = pointsMatch ? pointsMatch[0].replace(/\s+/g, ' ').trim() : '';

    if (title && /\boff\b/i.test(title)) {
      title = title.replace(/\s+your\s+next\s+order$/i, '') + ' your next order';
    }

    if (!title) {
      var textElements = Array.from(
        tile.querySelectorAll('h1, h2, h3, h4, h5, h6, strong, b, [class*="title"], [class*="headline"]')
      );

      var titleElement = textElements.find(function (element) {
        var text = element.textContent.replace(/\s+/g, ' ').trim();

        return (
          text &&
          text.toLowerCase().indexOf('redeem') === -1 &&
          !/\b\d+\s*points?\b/i.test(text)
        );
      });

      title = titleElement ? titleElement.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    return {
      title: title,
      points: points,
      button: button
    };
  }

  function collectRewardOptions(redemptionInstance) {
    if (!redemptionInstance) {
      return [];
    }

    var buttons = Array.from(
      redemptionInstance.querySelectorAll('button, a')
    ).filter(function (button) {
      return button.textContent.trim().toLowerCase().indexOf('redeem') !== -1;
    });

    var seenTiles = new Set();

    return buttons.reduce(function (options, button) {
      var tile = getRewardTileFromButton(button, redemptionInstance);

      if (!tile || seenTiles.has(tile)) {
        return options;
      }

      seenTiles.add(tile);

      var reward = getRewardData(tile, button);

      if (reward.points) {
        options.push(reward);
      }

      return options;
    }, []);
  }

  function updatePointsBalance(targetSection, rewardsWidget) {
    var balanceTarget = targetSection.querySelector(
      '.cw-points-can-become__balance-value'
    );

    if (!balanceTarget || !rewardsWidget) {
      return;
    }

    var balanceSource = rewardsWidget.querySelector(
      '.yotpo-description-points-balance .yotpo-inner-text'
    );

    if (!balanceSource) {
      return;
    }

    var balanceMatch = balanceSource.textContent.match(/\d[\d,]*/);

    if (balanceMatch) {
      balanceTarget.textContent = balanceMatch[0];
    }
  }

  function prepareRedemptionWidget(redemptionInstance, rewardsWidget) {
    var targetSection = document.querySelector(
      '.cw-points-can-become[data-cw-yotpo-redemption-target="true"]'
    );

    if (!targetSection || !redemptionInstance) {
      return false;
    }

    var rewardOptions = collectRewardOptions(redemptionInstance);
    var targetCards = Array.from(
      targetSection.querySelectorAll('.cw-points-can-become__card')
    );

    if (!rewardOptions.length || !targetCards.length) {
      return false;
    }

    targetCards.forEach(function (card, index) {
      var reward = rewardOptions[index];
      var title = card.querySelector('.cw-points-can-become__card-title');
      var points = card.querySelector('.cw-points-can-become__points');
      var action = card.querySelector('.cw-points-can-become__card-action');

      if (!reward) {
        card.style.display = 'none';
        return;
      }

      card.style.removeProperty('display');

      if (title && reward.title) {
        title.textContent = reward.title;
      }

      if (points && reward.points) {
        points.textContent = reward.points;
      }

      if (action && !action.contains(reward.button)) {
        action.innerHTML = '';
        reward.button.classList.add('cw-points-can-become__native-redeem');
        action.appendChild(reward.button);
      }
    });

    updatePointsBalance(targetSection, rewardsWidget);

    redemptionInstance.classList.add('cw-yotpo-redemption-source-hidden');
    targetSection.dataset.cwYotpoReady = 'true';

    return true;
  }

  function run() {
    var widgets = getWidgets();

    if (!widgets.campaign) {
      return false;
    }

    injectStyles();
    isolateYotpoInstances();
    prepareHeader(widgets.campaign);
    prepareCards(widgets.campaign);
    prepareRewardsWidget(widgets.rewards);

    document.body.classList.add('cw-yotpo-ways-ready');

    return true;
  }

  function init() {
    var attempts = 0;
    var maxAttempts = 100;

    var interval = window.setInterval(function () {
      attempts += 1;

      var done = run();

      if (done || attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 250);

    window.setTimeout(run, 1500);
    window.setTimeout(run, 3000);
    window.setTimeout(run, 5000);

    window.addEventListener('load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* =========================================================================
 * SCRIPT 2 — "What Your Points Can Become" redemption cards section
 * ========================================================================= */
(function () {
  var CONFIG = {
    sectionId: 'cw-yotpo-redemption-rendered',
    styleId: 'cw-yotpo-redemption-rendered-css',
    mainColor: '#09152B',
    textColor: '#666666',
    accentColor: '#ECC643',
    backgroundColor: '#F5EFE3',
    cardBackground: 'rgba(255, 255, 255, 0.18)',
    borderColor: '#09152B',
    heading: 'What Your Points Can Become.',
    conversionText: '',
    description:
      'Redeeming your points is easy! Just click Redeem my points, and select an eligible reward.',
    icons: [
      `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <path d="M26.6347 18.7252C26.3071 18.3976 25.7746 18.3976 25.447 18.7252L15.367 28.8052C15.0394 29.1328 15.0394 29.6654 15.367 29.993C15.5299 30.1576 15.745 30.2399 15.96 30.2399C16.1751 30.2399 16.3901 30.1576 16.5547 29.9946L26.6347 19.9146C26.9623 19.5854 26.9623 19.0545 26.6347 18.7252Z" fill="#09152B"/>
        <path d="M19.32 20.9999C19.32 19.1469 17.813 17.6399 15.96 17.6399C14.107 17.6399 12.6 19.1469 12.6 20.9999C12.6 22.8529 14.107 24.3599 15.96 24.3599C17.813 24.3599 19.32 22.8529 19.32 20.9999ZM14.28 20.9999C14.28 20.0725 15.0343 19.3199 15.96 19.3199C16.8857 19.3199 17.64 20.0725 17.64 20.9999C17.64 21.9273 16.8857 22.6799 15.96 22.6799C15.0343 22.6799 14.28 21.9273 14.28 20.9999Z" fill="#09152B"/>
        <path d="M26.04 24.3599C24.187 24.3599 22.68 25.8668 22.68 27.7199C22.68 29.5729 24.187 31.0799 26.04 31.0799C27.8931 31.0799 29.4 29.5729 29.4 27.7199C29.4 25.8668 27.8931 24.3599 26.04 24.3599ZM26.04 29.3999C25.1143 29.3999 24.36 28.6472 24.36 27.7199C24.36 26.7925 25.1143 26.0399 26.04 26.0399C26.9657 26.0399 27.72 26.7925 27.72 27.7199C27.72 28.6472 26.9657 29.3999 26.04 29.3999Z" fill="#09152B"/>
        <path d="M33.6 10.92H28.513C28.093 7.14499 24.8842 4.19995 21 4.19995C17.1159 4.19995 13.9054 7.14499 13.4871 10.92H8.40001C6.08497 10.92 4.20001 12.8032 4.20001 15.12V33.6C4.20001 35.9167 6.08497 37.8 8.40001 37.8H33.6C35.9151 37.8 37.8 35.9167 37.8 33.6V15.12C37.8 12.8032 35.9151 10.92 33.6 10.92ZM36.12 33.6C36.12 34.9893 34.9894 36.12 33.6 36.12H8.40001C7.01065 36.12 5.88001 34.9893 5.88001 33.6V15.12C5.88001 13.7306 7.01065 12.6 8.40001 12.6H14.28C14.7437 12.6 15.12 12.2236 15.12 11.76C15.12 8.51755 17.7576 5.87995 21 5.87995C24.2424 5.87995 26.88 8.51755 26.88 11.76C26.88 12.2236 27.2563 12.6 27.72 12.6H33.6C34.9894 12.6 36.12 13.7306 36.12 15.12V33.6Z" fill="#09152B"/>
        <path d="M21 11.7598C21.4639 11.7598 21.84 11.3838 21.84 10.9198C21.84 10.4559 21.4639 10.0798 21 10.0798C20.5361 10.0798 20.16 10.4559 20.16 10.9198C20.16 11.3838 20.5361 11.7598 21 11.7598Z" fill="#09152B"/>
      </svg>`,
      `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <path d="M19.6875 16.4062C19.6875 15.7573 19.495 15.1229 19.1345 14.5833C18.7739 14.0437 18.2615 13.6231 17.6619 13.3748C17.0623 13.1264 16.4026 13.0614 15.7661 13.188C15.1296 13.3147 14.5449 13.6272 14.086 14.0861C13.6271 14.5449 13.3146 15.1296 13.188 15.7661C13.0614 16.4026 13.1264 17.0624 13.3748 17.6619C13.6231 18.2615 14.0437 18.774 14.5833 19.1345C15.1229 19.4951 15.7573 19.6875 16.4062 19.6875C17.2762 19.6865 18.1102 19.3404 18.7253 18.7253C19.3404 18.1102 19.6864 17.2762 19.6875 16.4062ZM14.4375 16.4062C14.4375 16.0169 14.5529 15.6362 14.7693 15.3125C14.9856 14.9887 15.2931 14.7364 15.6528 14.5874C16.0126 14.4384 16.4084 14.3994 16.7903 14.4753C17.1722 14.5513 17.523 14.7388 17.7984 15.0141C18.0737 15.2895 18.2612 15.6403 18.3372 16.0222C18.4131 16.4041 18.3741 16.7999 18.2251 17.1597C18.0761 17.5194 17.8238 17.8269 17.5 18.0432C17.1763 18.2595 16.7956 18.375 16.4062 18.375C15.8841 18.375 15.3833 18.1676 15.0141 17.7984C14.6449 17.4292 14.4375 16.9284 14.4375 16.4062ZM25.5937 22.3125C24.9448 22.3125 24.3104 22.5049 23.7708 22.8655C23.2312 23.226 22.8106 23.7385 22.5623 24.3381C22.3139 24.9376 22.2489 25.5974 22.3755 26.2339C22.5021 26.8704 22.8147 27.4551 23.2735 27.9139C23.7324 28.3728 24.3171 28.6853 24.9536 28.812C25.5901 28.9386 26.2498 28.8736 26.8494 28.6252C27.449 28.3769 27.9615 27.9563 28.322 27.4167C28.6825 26.8771 28.875 26.2427 28.875 25.5938C28.8739 24.7238 28.5279 23.8898 27.9128 23.2747C27.2977 22.6596 26.4637 22.3135 25.5937 22.3125ZM25.5937 27.5625C25.2044 27.5625 24.8237 27.447 24.5 27.2307C24.1762 27.0144 23.9239 26.7069 23.7749 26.3472C23.6258 25.9874 23.5869 25.5916 23.6628 25.2097C23.7388 24.8278 23.9263 24.477 24.2016 24.2016C24.477 23.9263 24.8278 23.7388 25.2097 23.6628C25.5916 23.5869 25.9874 23.6259 26.3471 23.7749C26.7069 23.9239 27.0144 24.1762 27.2307 24.5C27.447 24.8237 27.5625 25.2044 27.5625 25.5938C27.5625 26.1159 27.3551 26.6167 26.9859 26.9859C26.6166 27.3551 26.1159 27.5625 25.5937 27.5625ZM39.1361 16.4929C39.5767 16.4012 39.9719 16.1598 40.2547 15.8098C40.5375 15.4598 40.6904 15.0227 40.6875 14.5727V10.5C40.6865 9.63008 40.3404 8.79608 39.7253 8.18096C39.1102 7.56583 38.2762 7.21979 37.4062 7.21875H4.59373C3.72381 7.21979 2.88982 7.56583 2.27469 8.18096C1.65956 8.79608 1.31352 9.63008 1.31248 10.5V14.5727C1.30956 15.0227 1.46248 15.4598 1.74528 15.8098C2.02807 16.1598 2.42331 16.4012 2.86386 16.4929C3.90803 16.6986 4.84839 17.2604 5.52429 18.0825C6.20019 18.9045 6.56971 19.9358 6.56971 21C6.56971 22.0642 6.20019 23.0955 5.52429 23.9175C4.84839 24.7396 3.90803 25.3014 2.86386 25.5071C2.42331 25.5988 2.02807 25.8402 1.74528 26.1902C1.46248 26.5402 1.30956 26.9773 1.31248 27.4273V31.5C1.31352 32.3699 1.65956 33.2039 2.27469 33.819C2.88982 34.4342 3.72381 34.7802 4.59373 34.7812H37.4062C38.2762 34.7802 39.1102 34.4342 39.7253 33.819C40.3404 33.2039 40.6865 32.3699 40.6875 31.5V27.4273C40.6904 26.9773 40.5375 26.5402 40.2547 26.1902C39.9719 25.8402 39.5767 25.5988 39.1361 25.5071C38.0919 25.3014 37.1516 24.7396 36.4757 23.9175C35.7998 23.0955 35.4303 22.0642 35.4303 21C35.4303 19.9358 35.7998 18.9045 36.4757 18.0825C37.1516 17.2604 38.0919 16.6986 39.1361 16.4929ZM34.125 21C34.1267 22.3667 34.6014 23.6906 35.4686 24.747C36.3358 25.8033 37.542 26.5268 38.8821 26.7947C39.0247 26.8269 39.1518 26.9076 39.2416 27.0229C39.3315 27.1383 39.3786 27.2812 39.375 27.4273V31.5C39.375 32.0221 39.1676 32.5229 38.7984 32.8921C38.4291 33.2613 37.9284 33.4688 37.4062 33.4688H4.59373C4.07159 33.4688 3.57083 33.2613 3.20161 32.8921C2.8324 32.5229 2.62498 32.0221 2.62498 31.5V27.4273C2.6215 27.2812 2.66868 27.1384 2.75851 27.0231C2.84834 26.9077 2.97529 26.8271 3.11782 26.7947C4.46013 26.53 5.66891 25.8076 6.53774 24.7507C7.40657 23.6939 7.88154 22.3681 7.88154 21C7.88154 19.6319 7.40657 18.3061 6.53774 17.2493C5.66891 16.1924 4.46013 15.47 3.11782 15.2053C2.97529 15.1729 2.84834 15.0923 2.75851 14.977C2.66868 14.8616 2.6215 14.7188 2.62498 14.5727V10.5C2.62498 9.97785 2.8324 9.4771 3.20161 9.10788C3.57083 8.73867 4.07159 8.53125 4.59373 8.53125H37.4062C37.9284 8.53125 38.4291 8.73867 38.7984 9.10788C39.1676 9.4771 39.375 9.97785 39.375 10.5V14.5727C39.3786 14.7188 39.3315 14.8617 39.2416 14.9771C39.1518 15.0924 39.0247 15.1731 38.8821 15.2053C37.542 15.4732 36.3358 16.1967 35.4686 17.253C34.6014 18.3094 34.1267 19.6333 34.125 21ZM27.3702 15.5577L15.5577 27.3702C15.4339 27.4898 15.2682 27.5559 15.0961 27.5544C14.924 27.5529 14.7594 27.4839 14.6378 27.3622C14.5161 27.2406 14.4471 27.076 14.4456 26.9039C14.4441 26.7318 14.5102 26.5661 14.6298 26.4423L26.4423 14.6298C26.566 14.5102 26.7318 14.4441 26.9039 14.4456C27.0759 14.4471 27.2405 14.5161 27.3622 14.6378C27.4839 14.7594 27.5529 14.924 27.5544 15.0961C27.5559 15.2682 27.4897 15.4339 27.3702 15.5577Z" fill="#09152B"/>
      </svg>`,
      `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <g clip-path="url(#cw-redemption-clip)">
          <path d="M21 0C19.8422 0 18.9 0.9422 18.9 2.1V2.8H16.646C15.7843 2.8 14.917 3.0772 14.2016 3.5812L8.7549 7.4809C7.6566 8.2698 7 9.5473 7 10.899V37.8C7 40.1163 8.8837 42 11.2 42H30.8C33.1163 42 35 40.1163 35 37.8V10.899C35 9.5473 34.3434 8.2698 33.2444 7.4802L27.7942 3.5784C27.0823 3.0765 26.2157 2.8 25.354 2.8H23.1V2.1C23.1 0.9422 22.1578 0 21 0ZM23.1 9.8C23.1 10.9578 22.1578 11.9 21 11.9C19.8422 11.9 18.9 10.9578 18.9 9.8C18.9 9.5599 18.9546 9.331 19.0323 9.1105C19.3249 9.9183 20.0928 10.5 21 10.5C21.9072 10.5 22.6751 9.9183 22.9677 9.1112C23.0454 9.3317 23.1 9.5606 23.1 9.8ZM20.3 2.1C20.3 1.7136 20.6136 1.4 21 1.4C21.3864 1.4 21.7 1.7136 21.7 2.1V8.4C21.7 8.7864 21.3864 9.1 21 9.1C20.6136 9.1 20.3 8.7864 20.3 8.4V2.1ZM25.354 4.2C25.9294 4.2 26.5097 4.3862 26.9836 4.7201L32.4289 8.6184C33.1625 9.1448 33.6 9.9974 33.6 10.899V37.8C33.6 39.3442 32.3442 40.6 30.8 40.6H11.2C9.6558 40.6 8.4 39.3442 8.4 37.8V10.899C8.4 9.9974 8.8375 9.1448 9.5704 8.6191L15.0122 4.7229C15.4903 4.3862 16.0706 4.2 16.646 4.2H18.9V7.0056C18.0285 7.6601 17.5 8.6954 17.5 9.8C17.5 11.7299 19.0701 13.3 21 13.3C22.9299 13.3 24.5 11.7299 24.5 9.8C24.5 8.6947 23.9715 7.6594 23.1 7.0056V4.2H25.354Z" fill="#09152B"/>
          <path d="M13.5051 33.3948C13.6416 33.5313 13.8208 33.5999 14 33.5999C14.1792 33.5999 14.3584 33.5313 14.4949 33.3948L28.4949 19.3948C28.7686 19.1211 28.7686 18.6787 28.4949 18.405C28.2212 18.1313 27.7788 18.1313 27.5051 18.405L13.5051 32.405C13.2314 32.6787 13.2314 33.1211 13.5051 33.3948Z" fill="#09152B"/>
          <path d="M16.8 25.2C18.7299 25.2 20.3 23.6299 20.3 21.7C20.3 19.7701 18.7299 18.2 16.8 18.2C14.8701 18.2 13.3 19.7701 13.3 21.7C13.3 23.6299 14.8701 25.2 16.8 25.2ZM16.8 19.6C17.9578 19.6 18.9 20.5422 18.9 21.7C18.9 22.8578 17.9578 23.8 16.8 23.8C15.6422 23.8 14.7 22.8578 14.7 21.7C14.7 20.5422 15.6422 19.6 16.8 19.6Z" fill="#09152B"/>
          <path d="M25.2 26.6001C23.2701 26.6001 21.7 28.1702 21.7 30.1001C21.7 32.03 23.2701 33.6001 25.2 33.6001C27.1299 33.6001 28.7 32.03 28.7 30.1001C28.7 28.1702 27.1299 26.6001 25.2 26.6001ZM25.2 32.2001C24.0422 32.2001 23.1 31.2579 23.1 30.1001C23.1 28.9423 24.0422 28.0001 25.2 28.0001C26.3578 28.0001 27.3 28.9423 27.3 30.1001C27.3 31.2579 26.3578 32.2001 25.2 32.2001Z" fill="#09152B"/>
        </g>
        <defs>
          <clipPath id="cw-redemption-clip">
            <rect width="42" height="42" fill="white"/>
          </clipPath>
        </defs>
      </svg>`
    ]
  };

  // Shared matchers used across several lookup helpers below.
  var POINTS_PATTERN = /\b\d[\d,]*\s*points?\b/i;
  var MONEY_PATTERN = /\$\s*\d+(?:\.\d{1,2})?\s*(?:off)?/i;

  var observer = null;
  var updateQueued = false;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var styles = window.getComputedStyle(element);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0' &&
      element.getClientRects().length > 0
    );
  }

  function isCustomerLoggedIn() {
    var loggedInView = document.querySelector(
      '.yotpo-widget-my-rewards-widget .yotpo-logged-in-view'
    );

    var pointsBalance = document.querySelector(
      '.yotpo-description-points-balance .yotpo-inner-text'
    );

    var rewardsButton = document.querySelector(
      '.yotpo-widget-my-rewards-widget .yotpo-primary-button'
    );

    return (
      isVisible(loggedInView) ||
      !!pointsBalance ||
      !!rewardsButton
    );
  }

  function isRewardsPage() {
    var path = window.location.pathname.replace(/\/$/, '');

    if (path === '/pages/rewards') {
      return true;
    }

    var params = new URLSearchParams(window.location.search);
    var previewPath = params.get('previewPath');

    return (
      previewPath &&
      previewPath.replace(/\/$/, '') === '/pages/rewards'
    );
  }

  function injectStyles() {
    if (document.getElementById(CONFIG.styleId)) {
      return;
    }

    var style = document.createElement('style');
    style.id = CONFIG.styleId;
    style.textContent = `
      #${CONFIG.sectionId} {
        width: 100%;
        order: 3 !important;
        background: linear-gradient(
          90deg,
          rgba(245, 239, 227, 0) 0%,
          ${CONFIG.backgroundColor} 50%,
          rgba(245, 239, 227, 0) 100%
        );
        overflow: hidden;
      }

      #${CONFIG.sectionId} * {
        box-sizing: border-box;
      }

      #${CONFIG.sectionId} .cw-redemption__inner {
        width: 100%;
        max-width: 1500px;
        margin: 0 auto;
        padding: 90px 100px 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 34px;
      }

      #${CONFIG.sectionId} .cw-redemption__header {
        width: 100%;
        max-width: 850px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
      }

      #${CONFIG.sectionId} .cw-redemption__heading {
        margin: 0;
        color: ${CONFIG.mainColor};
        font-family: Montserrat, sans-serif;
        font-size: 42px;
        font-weight: 600;
        line-height: 1.25;
        text-align: center;
      }

      #${CONFIG.sectionId} .cw-redemption__conversion {
        display: none;
      }

      #${CONFIG.sectionId} .cw-redemption__description {
        max-width: 700px;
        margin: 0;
        color: ${CONFIG.textColor};
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.4;
        text-align: center;
      }

      #${CONFIG.sectionId} .cw-redemption__balance {
        display: block;
        width: 100%;
        margin: 0;
        color: ${CONFIG.mainColor};
        font-family: Montserrat, sans-serif;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.4;
        text-align: center;
      }

      #${CONFIG.sectionId} .cw-redemption__balance-value {
        color: inherit;
      }

      #${CONFIG.sectionId} .cw-redemption__cards {
        width: 100%;
        max-width: 1058px;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
      }

      #${CONFIG.sectionId} .cw-redemption__card {
        min-height: 220px;
        padding: 24px 30px 22px;
        border: 1px solid ${CONFIG.borderColor};
        border-radius: 12px;
        background: ${CONFIG.cardBackground};
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: flex-start;
      }

      #${CONFIG.sectionId} .cw-redemption__icon {
        width: 42px;
        height: 42px;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      #${CONFIG.sectionId} .cw-redemption__icon svg {
        width: 42px;
        height: 42px;
        display: block;
      }

      #${CONFIG.sectionId} .cw-redemption__title {
        margin: 0;
        color: ${CONFIG.mainColor};
        font-family: Montserrat, sans-serif;
        font-size: 20px;
        font-weight: 600;
        line-height: 1.2;
        text-align: center;
      }

      #${CONFIG.sectionId} .cw-redemption__points {
        margin: 3px 0 18px;
        color: ${CONFIG.textColor};
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.4;
        text-align: center;
         position: relative;
        top: 10px;
      }

      #${CONFIG.sectionId} .cw-redemption__action {
        width: 100%;
        margin-top: auto;
      }

      #${CONFIG.sectionId} .cw-redemption__button {
        width: 70% !important;
        min-width: 0 !important;
        height: 40px !important;
        min-height: 40px !important;
        margin: 0 !important;
        padding: 12px 16px !important;
        border: 1px solid ${CONFIG.mainColor} !important;
        border-radius: 3px !important;
        background: ${CONFIG.mainColor} !important;
        color: #FFFFFF !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        line-height: 1.2 !important;
        text-align: center !important;
        text-transform: uppercase !important;
        text-decoration: none !important;
        cursor: pointer !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-sizing: border-box !important;
        --font-family: Montserrat, sans-serif !important;
        --font-size: 14px !important;
        --font-weight: 600 !important;
        --text-color: #FFFFFF !important;
      }

      #${CONFIG.sectionId} .cw-redemption__button .yotpo-button-label {
        font-size: inherit !important;
        font-family: inherit !important;
        font-weight: inherit !important;
        line-height: inherit !important;
        color: inherit !important;
        white-space: nowrap !important;
      }

      #${CONFIG.sectionId} .cw-redemption__button:disabled,
      #${CONFIG.sectionId} .cw-redemption__button[disabled],
      #${CONFIG.sectionId} .cw-redemption__button[aria-disabled="true"] {
        border-color: #9B9B9B !important;
        background: #9B9B9B !important;
        color: #FFFFFF !important;
        cursor: not-allowed !important;
        opacity: 1 !important;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__cards {
        max-width: 1094px;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__card {
        width: 100%;
        min-width: 0;
        min-height: 173px;
        padding: 24px;
        border: none;
        outline: 1px solid #000000;
        outline-offset: -1px;
        border-radius: 15.99px;
        background: #F7F6F2;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 0;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__icon {
        width: 54.97px;
        height: 54.97px;
        margin: 0 0 16px;
        padding-left: 2px;
        justify-content: flex-start;
        overflow: hidden;
        border-radius: 8px;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__icon svg {
        width: 42px;
        height: 42px;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__title {
        width: 100%;
        margin: 0 0 8px;
        font-size: 20px;
        line-height: 24px;
        text-align: left;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__points {
        width: 100%;
        margin: 0;
        color: #181F2E;
        font-size: 16px;
        line-height: 22.4px;
        text-align: left;
      }

      #${CONFIG.sectionId} .cw-redemption__logged-out-cta {
        width: 242px;
        height: 60px;
        margin: 16px auto 0;
        padding: 16px 10px;
        border-radius: 3px;
        background: ${CONFIG.mainColor};
        color: #FFFFFF;
        font-family: Montserrat, sans-serif;
        font-size: 16px;
        font-weight: 600;
        line-height: 22.4px;
        text-align: center;
        text-transform: uppercase;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-sizing: border-box;
      }

      .cw-yotpo-redemption-source-hidden {
        display: none !important;
      }

      @media screen and (max-width: 749px) {
        #${CONFIG.sectionId} {
          background: linear-gradient(
            270deg,
            rgba(245, 239, 227, 0) 0%,
            ${CONFIG.backgroundColor} 50%,
            rgba(245, 239, 227, 0) 100%
          );
        }

        #${CONFIG.sectionId} .cw-redemption__inner {
          max-width: 390px;
          padding: 45px 20px;
          gap: 28px;
        }

        #${CONFIG.sectionId} .cw-redemption__header {
          max-width: 350px;
          gap: 10px;
        }

        #${CONFIG.sectionId} .cw-redemption__heading {
          font-size: 26px;
          line-height: 1.3;
        }

        #${CONFIG.sectionId} .cw-redemption__conversion {
          font-size: 17px;
        }

        #${CONFIG.sectionId} .cw-redemption__description {
          font-size: 16px;
          line-height: 1.4;
        }

        #${CONFIG.sectionId} .cw-redemption__balance {
          font-size: 16px;
        }

        #${CONFIG.sectionId} .cw-redemption__cards {
          width: 100%;
          max-width: none;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          justify-content: center;
          gap: 16px;
        }

        #${CONFIG.sectionId} .cw-redemption__card {
          width: 100%;
          min-width: 0;
          min-height: 171px;
          padding: 15px;
          border-radius: 15.99px;
          align-items: flex-start;
          gap: 16px;
        }

        #${CONFIG.sectionId} .cw-redemption__card:last-child:nth-child(odd) {
          grid-column: 1 / -1;
          width: calc((100% - 16px) / 2);
          justify-self: center;
        }

        /*
          Logged-in card look, mobile only (excludes .cw-redemption--logged-out,
          which has its own dedicated styling further up). Matches the design
          spec: 12px vertical / 15px horizontal padding, 12px internal gap,
          #F7F6F2 fill, and a 1px black outline instead of a border so the
          rounded corners stay clean.
        */
        #${CONFIG.sectionId}:not(.cw-redemption--logged-out) .cw-redemption__card {
          min-height: 180px;
          padding: 12px 15px;
          gap: 8px !important;
          background: #F7F6F2;
          border: none;
          outline: 1px solid #000000;
          outline-offset: -1px;
        }

        #${CONFIG.sectionId}:not(.cw-redemption--logged-out) .cw-redemption__icon {
          border-radius: 8px;
          overflow: hidden;
        }

        /*
          Same card treatment as above, mirrored for the logged-out
          placeholder cards. Intentionally does NOT touch the CTA
          (.cw-redemption__logged-out-cta) -- only the card shell/icon.
        */
        #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__card {
          padding: 15px;
          gap: 0;
          background: #F7F6F2;
          border: none;
          outline: 1px solid #000000;
          outline-offset: -1px;
        }

        #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__icon {
          border-radius: 8px;
          overflow: hidden;
          margin-top: 10px;
        }

        #${CONFIG.sectionId} .cw-redemption__icon {
          width: 54.97px;
          height: 54.97px;
          margin-bottom: 0;
          padding-left: 2px;
          justify-content: flex-start;
        }

        #${CONFIG.sectionId} .cw-redemption__icon svg {
          width: 32px;
          height: 32px;
        }

        #${CONFIG.sectionId} .cw-redemption__title {
          width: 100%;
          font-size: 16px;
          line-height: 19.2px;
          text-align: left;
          margin-top: 10px;
        }

        /*
          The desktop rule for .cw-redemption--logged-out .cw-redemption__title
          (font-size: 20px) is more specific than the generic mobile rule above,
          so it wins on mobile too unless we re-target it here. This restores
          the intended 16px mobile size so the title wraps naturally instead of
          forcing an oversized 3-line break.
        */
        #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__title {
          margin-bottom: 12px;
          font-size: 16px;
          line-height: 19.2px;
        }

        #${CONFIG.sectionId} .cw-redemption__points {
          width: 100%;
          margin: 0 0 12px;
          font-size: 14px;
          line-height: 19.6px;
          text-align: left;
          position: relative;
        }

        #${CONFIG.sectionId} .cw-redemption__action {
          margin-top: auto;
        }

        /*
          Logged-in CTA on mobile: smaller, muted grey pill instead of the
          full-size navy button used on desktop.
        */
        #${CONFIG.sectionId} .cw-redemption__button {
        width: 100% !important;
        height: 100% !important;
          height: 37px !important;
          min-height: 37px !important;
          padding: 16px 10px !important;
          background: #95989C !important;
          border-color: #95989C !important;
          font-size: 11px !important;
          line-height: 15.4px !important;
          gap: 10px !important;
          --font-size: 11px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function findRewardsWidget() {
    var widgets = Array.from(
      document.querySelectorAll('.yotpo-widget-my-rewards-widget')
    );

    return widgets.find(function (widget) {
      return !!widget.querySelector('.yotpo-logged-in-view');
    }) || null;
  }

  function findRewardTile(button, root) {
    var node = button;

    while (node && node !== root) {
      var text = normalizeText(node.textContent).toLowerCase();

      if (text.includes('redeem') && POINTS_PATTERN.test(text)) {
        return node;
      }

      node = node.parentElement;
    }

    return button.parentElement;
  }

  function findRedemptionSource() {
    var buttons = Array.from(
      document.querySelectorAll(
        '.yotpo-widget-instance-container button, .yotpo-widget-instance-container a'
      )
    ).filter(function (button) {
      return normalizeText(button.textContent)
        .toLowerCase()
        .includes('redeem');
    });

    var redeemButton = buttons.find(function (button) {
      var instance = button.closest('.yotpo-widget-instance-container');

      if (
        !instance ||
        instance.querySelector('.yotpo-widget-campaign-widget') ||
        instance.querySelector('.yotpo-widget-my-rewards-widget') ||
        instance.closest('#' + CONFIG.sectionId)
      ) {
        return false;
      }

      var tile = findRewardTile(button, instance);
      var text = normalizeText(tile ? tile.textContent : '');

      return POINTS_PATTERN.test(text);
    });

    if (!redeemButton) {
      return null;
    }

    var instance = redeemButton.closest('.yotpo-widget-instance-container');

    return {
      instance: instance,
      root:
        redeemButton.closest(
          '.yotpo-redemption-widget, .yotpo-widget-redemption-widget, .yotpo-reward-options-list, .yotpo-rewards-list, .yotpo-widget-redemption'
        ) || instance
    };
  }

  function readRewardData(tile, button) {
    var text = normalizeText(tile.textContent);
    var pointsMatch = text.match(POINTS_PATTERN);
    var moneyMatch = text.match(MONEY_PATTERN);

    var title = moneyMatch
      ? normalizeText(moneyMatch[0])
      : '';

    if (title && /\boff\b/i.test(title)) {
      title = title.replace(/\s+your\s+next\s+order$/i, '') + ' your next order';
    }

    if (!title) {
      var titleCandidates = Array.from(
        tile.querySelectorAll(
          'h1, h2, h3, h4, h5, h6, strong, b, [class*="title"], [class*="headline"]'
        )
      );

      var titleElement = titleCandidates.find(function (element) {
        var candidate = normalizeText(element.textContent);
        var lower = candidate.toLowerCase();

        return (
          candidate &&
          !lower.includes('redeem') &&
          !POINTS_PATTERN.test(candidate)
        );
      });

      title = titleElement
        ? normalizeText(titleElement.textContent)
        : '';
    }

    return {
      title: title,
      points: pointsMatch ? normalizeText(pointsMatch[0]) : '',
      button: button,
      tile: tile
    };
  }

  function collectRewards(root) {
    var buttons = Array.from(
      root.querySelectorAll('button, a')
    ).filter(function (button) {
      return normalizeText(button.textContent)
        .toLowerCase()
        .includes('redeem');
    });

    var seenTiles = new Set();

    return buttons.reduce(function (rewards, button) {
      var tile = findRewardTile(button, root);

      if (!tile || seenTiles.has(tile)) {
        return rewards;
      }

      seenTiles.add(tile);

      var reward = readRewardData(tile, button);

      if (reward.points) {
        rewards.push(reward);
      }

      return rewards;
    }, []);
  }

  function getBalance() {
    var rewardsWidget = findRewardsWidget();

    if (!rewardsWidget) {
      return '0';
    }

    var balanceElement = rewardsWidget.querySelector(
      '.yotpo-description-points-balance .yotpo-inner-text'
    );

    if (!balanceElement) {
      return '0';
    }

    var match = normalizeText(balanceElement.textContent).match(/\d[\d,]*/);

    return match ? match[0] : '0';
  }

  function createSection(rewards) {
    var section = document.getElementById(CONFIG.sectionId);

    if (!section) {
      section = document.createElement('section');
      section.id = CONFIG.sectionId;
    }

    section.innerHTML = `
      <div class="cw-redemption__inner">
        <div class="cw-redemption__header">
          <h2 class="cw-redemption__heading">${CONFIG.heading}</h2>
          <div class="cw-redemption__conversion">${CONFIG.conversionText}</div>
          <p class="cw-redemption__description">${CONFIG.description}</p>
        </div>

        <p class="cw-redemption__balance">
          You have <span class="cw-redemption__balance-value">${getBalance()}</span> points!
        </p>

        <div class="cw-redemption__cards"></div>
      </div>
    `;

    var cards = section.querySelector('.cw-redemption__cards');

    rewards.slice(0, 3).forEach(function (reward, index) {
      var card = document.createElement('article');
      card.className = 'cw-redemption__card';

      card.innerHTML = `
        <div class="cw-redemption__icon" aria-hidden="true">
          ${CONFIG.icons[index] || CONFIG.icons[0]}
        </div>

        <h3 class="cw-redemption__title">
          ${reward.title || 'Reward'}
        </h3>

        <div class="cw-redemption__points">
          ${reward.points}
        </div>

        <div class="cw-redemption__action"></div>
      `;

      var action = card.querySelector('.cw-redemption__action');

      reward.button.classList.add('cw-redemption__button');

      var buttonLabel = reward.button.querySelector(
        '.yotpo-button-label, [class*="button-label"], span'
      );

      if (buttonLabel) {
        buttonLabel.textContent = 'REDEEM MY POINTS';
      } else {
        reward.button.textContent = 'REDEEM MY POINTS';
      }

      action.appendChild(reward.button);
      cards.appendChild(card);
    });

    return section;
  }

  function insertSection(section, redemptionInstance) {
    var loyaltyPage =
      document.querySelector('.yotpo-widget-loyalty-page') ||
      document.querySelector('.yotpo-loyalty-page-container');

    var campaignInstance = document.querySelector(
      '.yotpo-widget-instance-container:has(.yotpo-widget-campaign-widget)'
    );

    if (campaignInstance && campaignInstance.parentNode) {
      campaignInstance.insertAdjacentElement('afterend', section);
      return;
    }

    if (redemptionInstance && redemptionInstance.parentNode) {
      redemptionInstance.parentNode.insertBefore(
        section,
        redemptionInstance.nextSibling
      );
      return;
    }

    if (loyaltyPage) {
      loyaltyPage.appendChild(section);
    }
  }

  function buildLoggedOutSection() {
    var loggedOutRewards = [
      { title: '$5 off your next order', points: '100 points', button: document.createElement('a') },
      { title: '$10 off your next order', points: '200 points', button: document.createElement('a') },
      { title: '$15 off your next order', points: '300 points', button: document.createElement('a') }
    ];

    loggedOutRewards.forEach(function (reward) {
      reward.button.href = '/account/login';
      reward.button.textContent = 'REDEEM MY POINTS';
    });

    var loggedOutSection = createSection(loggedOutRewards);
    loggedOutSection.classList.add('cw-redemption--logged-out');

    var balance = loggedOutSection.querySelector('.cw-redemption__balance');

    if (balance) {
      balance.remove();
    }

    loggedOutSection.querySelectorAll('.cw-redemption__action').forEach(function (action) {
      action.remove();
    });

    var loggedOutCta = document.createElement('a');
    loggedOutCta.className = 'cw-redemption__logged-out-cta';
    loggedOutCta.href = '/account/login';
    loggedOutCta.textContent = 'REDEEM MY POINTS';

    loggedOutSection
      .querySelector('.cw-redemption__inner')
      .appendChild(loggedOutCta);

    return loggedOutSection;
  }

  function render() {
    injectStyles();

    if (!isCustomerLoggedIn()) {
      insertSection(buildLoggedOutSection(), null);
      return true;
    }

    var redemptionSource = findRedemptionSource();

    if (!redemptionSource) {
      return false;
    }

    var rewards = collectRewards(redemptionSource.root);

    if (!rewards.length) {
      return false;
    }

    var section = createSection(rewards);

    /*
      createSection() reuses the same #cw-yotpo-redemption-rendered element
      across renders. If an earlier pass rendered the logged-out placeholder
      (e.g. before Yotpo's auth state resolved) it left the
      "cw-redemption--logged-out" class behind, which would otherwise leak
      logged-out styling into these real, logged-in cards.
    */
    section.classList.remove('cw-redemption--logged-out');

    insertSection(section, redemptionSource.instance);

    /*
      Hide only the exact native redemption block.
      Never hide the whole Yotpo instance because it may also contain
      the rewards guide/cards or other widgets.
    */
    redemptionSource.root.classList.add(
      'cw-yotpo-redemption-source-hidden'
    );

    return true;
  }

  function scheduleRender() {
    if (updateQueued) {
      return;
    }

    updateQueued = true;

    window.requestAnimationFrame(function () {
      updateQueued = false;
      render();
    });
  }

  function init() {
    var attempts = 0;
    var maxAttempts = 120;

    var interval = window.setInterval(function () {
      attempts += 1;

      if (render() || attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 250);

    observer = new MutationObserver(scheduleRender);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener('load', scheduleRender);
  }

  if (!isRewardsPage()) {
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================================
 * SCRIPT 3 — Hide the "Sima Insiders" hero CTA buttons once logged in
 * ========================================================================= */
(function () {
  var BUTTONS_SELECTOR = '.sima-insiders-hero__buttons';

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var styles = window.getComputedStyle(element);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0' &&
      element.getClientRects().length > 0
    );
  }

  function isCustomerLoggedIn() {
    var loggedInView = document.querySelector(
      '.yotpo-widget-my-rewards-widget .yotpo-logged-in-view'
    );

    var pointsBalance = document.querySelector(
      '.yotpo-description-points-balance .yotpo-inner-text'
    );

    var loggedInButtons = document.querySelector(
      '.yotpo-action-buttons-tile .yotpo-primary-button'
    );

    return (
      isVisible(loggedInView) ||
      !!pointsBalance ||
      !!loggedInButtons
    );
  }

  function updateHeroButtonsVisibility() {
    var buttons = document.querySelector(BUTTONS_SELECTOR);

    if (!buttons) {
      return;
    }

    if (isCustomerLoggedIn()) {
      buttons.style.setProperty('display', 'none', 'important');
    } else {
      buttons.style.removeProperty('display');
    }
  }

  updateHeroButtonsVisibility();

  var observer = new MutationObserver(function () {
    updateHeroButtonsVisibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  window.addEventListener('load', updateHeroButtonsVisibility);
})();



// Contact Section


/* =========================================================================
 * SCRIPT 1 — Rewards page redesign ("Ways To Earn Points" widget)
 * ========================================================================= */
(function () {
  function isRewardsPage() {
    var path = window.location.pathname.replace(/\/$/, '');

    if (path === '/pages/rewards') {
      return true;
    }

    var params = new URLSearchParams(window.location.search);
    var previewPath = params.get('previewPath');

    if (previewPath && previewPath.replace(/\/$/, '') === '/pages/rewards') {
      return true;
    }

    return window.location.href.indexOf('previewPath=%2Fpages%2Frewards') !== -1;
  }

  if (!isRewardsPage()) {
    return;
  }

  var settings = {
    mainColor: '#09152B',
    textColor: '#181F2E',
    accentColor: '#ECC643',
    borderColor: '#000000',
    backgroundColor: '#FFFFFF',
    loggedInBg: '#F5EFE3',
    heading: 'Ways To Earn Points',
    subheading: 'Every action that helps the Sima community earns you points.',
    icons: {
      purchase: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/shopping-cart_4501806_2_1_763e5a02-aa05-493d-a550-ebff937a733c.svg?v=1784119371',
      join: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/balloon_13941477_1_5cab6100-7da0-4759-af52-f138b612c72c.svg?v=1784119377',
      subscription: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/sync_4074689_1_5cd3f1f5-599b-40c0-98aa-5bd98e125750.svg?v=1784119339',
      review: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/review_14990762_1_6cc4580c-2948-44f0-8125-76c670df748a.svg?v=1784119345',
      photo: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/camera_3679561_1_9c7b1afc-8903-4cef-9d7c-5421574889cf.svg?v=1784119348',
      video: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/video-player_10045692_1_c2240446-51af-4feb-a6ab-05d266572407.svg?v=1784119351',
      birthday: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/cake_16777864_1_bc07d895-f0a2-4c24-a13d-fed74920fc94.svg?v=1784119353',
      social: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/social_14068611_1_1d5394ed-61c0-4c16-8c43-cbdcd01b13ef.svg?v=1784119355',
      facebook: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2242%22%20height%3D%2242%22%20viewBox%3D%220%200%2042%2042%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M38.0631%209.84426C38.0631%206.58487%2035.4162%203.93799%2032.1568%203.93799H9.84426C6.58487%203.93799%203.93799%206.58487%203.93799%209.84426V32.1568C3.93799%2035.4162%206.58487%2038.0631%209.84426%2038.0631H32.1568C35.4162%2038.0631%2038.0631%2035.4162%2038.0631%2032.1568V9.84426ZM36.7506%209.84426V32.1568C36.7506%2034.6922%2034.6922%2036.7506%2032.1568%2036.7506H9.84426C7.30894%2036.7506%205.25049%2034.6922%205.25049%2032.1568V9.84426C5.25049%207.30894%207.30894%205.25049%209.84426%205.25049H32.1568C34.6922%205.25049%2036.7506%207.30894%2036.7506%209.84426Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M19.0318%2037.4065V24.9377H15.0942C14.732%2024.9377%2014.438%2024.6437%2014.438%2024.2814V19.6877C14.438%2019.3254%2014.732%2019.0314%2015.0942%2019.0314H19.0318V15.0939C19.0318%2011.8343%2021.6784%209.18762%2024.938%209.18762H30.8443C31.2065%209.18762%2031.5005%209.48162%2031.5005%209.84387V14.4376C31.5005%2014.7999%2031.2065%2015.0939%2030.8443%2015.0939H27.563C26.4763%2015.0939%2025.5943%2015.9759%2025.5943%2017.0626L25.5332%2019.0314H30.8443C31.0346%2019.0314%2031.2157%2019.1141%2031.3398%2019.2578C31.4644%2019.4015%2031.5209%2019.5918%2031.494%2019.7802L30.8377%2024.374C30.7918%2024.6975%2030.5149%2024.9377%2030.188%2024.9377H25.5943V37.4065H24.2818V24.2814C24.2818%2023.9192%2024.5758%2023.6252%2024.938%2023.6252H29.6191L30.0876%2020.3439H24.856C24.6781%2020.3439%2024.5082%2020.2717%2024.3848%2020.1444C24.2614%2020.0171%2024.1945%2019.8445%2024.1997%2019.6673C24.1997%2019.6673%2024.2818%2017.0515%2024.2818%2017.0541C24.2864%2015.2468%2025.7551%2013.7814%2027.563%2013.7814H30.188V10.5001H24.938C22.4029%2010.5001%2020.3443%2012.5588%2020.3443%2015.0939V19.6877C20.3443%2020.0499%2020.0503%2020.3439%2019.688%2020.3439H15.7505V23.6252H19.688C20.0503%2023.6252%2020.3443%2023.9192%2020.3443%2024.2814V37.4065H19.0318Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%3C%2Fsvg%3E',
      tiktok: 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2242%22%20height%3D%2242%22%20viewBox%3D%220%200%2042%2042%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url%28%23clip0_36_660%29%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M17.448%2035.7328C14.9542%2035.7328%2012.6082%2034.7648%2010.8363%2032.9929C9.07261%2031.2292%208.09644%2028.8832%208.09644%2026.3812C8.09644%2023.8875%209.07261%2021.5414%2010.8363%2019.7695C12.6%2018.0058%2014.946%2017.0296%2017.448%2017.0296C17.9156%2017.0296%2018.3914%2017.0625%2018.8507%2017.1363C19.1542%2017.1855%2019.3757%2017.4398%2019.3757%2017.7433V22.4109C19.3757%2022.6078%2019.2773%2022.7964%2019.1214%2022.9113C18.9574%2023.0261%2018.7523%2023.0589%2018.5636%2022.9933C18.2027%2022.8703%2017.8253%2022.8128%2017.448%2022.8128C15.4875%2022.8128%2013.8878%2024.4125%2013.8878%2026.373C13.8878%2028.3335%2015.4875%2029.9332%2017.448%2029.9332C17.8253%2029.9332%2018.2027%2029.8757%2018.5636%2029.7527C20.0156%2029.2687%2020.9917%2027.9234%2021%2026.3894V6.86597C21%206.52964%2021.2789%206.25073%2021.6152%206.25073H26.1761C26.5125%206.25073%2026.7914%206.52964%2026.7914%206.86597C26.7914%2010.4425%2029.7035%2013.3464%2033.28%2013.3464C33.6164%2013.3464%2033.8953%2013.6253%2033.8953%2013.9617V18.539C33.8953%2018.8753%2033.6164%2019.1542%2033.28%2019.1542C31.623%2019.1542%2030.0152%2018.8261%2028.4976%2018.1863C27.907%2017.932%2027.3328%2017.6367%2026.7914%2017.3003V26.4304C26.7832%2028.916%2025.807%2031.2457%2024.0515%2033.0011C22.6242%2034.4285%2020.8277%2035.339%2018.8507%2035.6343C18.3914%2035.7%2017.9156%2035.7328%2017.448%2035.7328ZM17.448%2018.2765C15.2824%2018.2765%2013.2398%2019.1214%2011.714%2020.6554C10.18%2022.1894%209.33511%2024.2238%209.33511%2026.3894C9.33511%2028.555%2010.18%2030.5976%2011.714%2032.1234C13.248%2033.6574%2015.2824%2034.5023%2017.448%2034.5023C17.8582%2034.5023%2018.2683%2034.4695%2018.6703%2034.4121C20.3847%2034.1578%2021.9515%2033.3621%2023.1902%2032.1234C24.716%2030.5976%2025.5609%2028.5714%2025.5691%2026.4222V16.1191C25.5691%2015.8812%2025.7003%2015.6679%2025.9136%2015.5695C26.1269%2015.4628%2026.373%2015.4875%2026.5617%2015.6351C27.3082%2016.2093%2028.1203%2016.6851%2028.9898%2017.0542C30.1628%2017.5546%2031.4015%2017.8335%2032.673%2017.9074V14.5769C28.9078%2014.2816%2025.8972%2011.2628%2025.5937%207.50581H22.2304V26.414C22.2222%2028.473%2020.9015%2030.2941%2018.9492%2030.9421C18.457%2031.1062%2017.9566%2031.1882%2017.4398%2031.1882C14.7984%2031.1882%2012.6492%2029.039%2012.6492%2026.3976C12.6492%2023.7562%2014.7984%2021.607%2017.4398%2021.607C17.6777%2021.607%2017.9074%2021.6234%2018.1371%2021.6562V18.3093C17.9156%2018.2847%2017.6777%2018.2765%2017.448%2018.2765Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M1.23047%207.87493V38.9238C1.23047%2039.9409%202.05898%2040.7695%203.07617%2040.7695H38.9238C39.941%2040.7695%2040.7695%2039.9409%2040.7695%2038.9238V30.089C40.7695%2029.7527%2041.0484%2029.4738%2041.3848%2029.4738C41.7211%2029.4738%2042%2029.7527%2042%2030.089V38.9238C42%2040.6218%2040.6219%2041.9999%2038.9238%2041.9999H3.07617C1.37812%2041.9999%200%2040.6218%200%2038.9238V7.87493C0%207.5386%200.270703%207.2679%200.598828%207.2597C0.951563%207.25149%201.23047%207.5304%201.23047%207.87493Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%20%20%20%20%3Cpath%20d%3D%22M0%203.79805V3.07617C0%201.37812%201.37812%200%203.07617%200H38.9238C40.6219%200%2042%201.37812%2042%203.07617V26.0285C42%2026.3648%2041.7211%2026.6437%2041.3848%2026.6437C41.0484%2026.6437%2040.7695%2026.3648%2040.7695%2026.0285V3.07617C40.7695%202.05898%2039.941%201.23047%2038.9238%201.23047H3.07617C2.05898%201.23047%201.23047%202.05898%201.23047%203.07617V3.79805C1.23047%204.13438%200.951562%204.41328%200.615234%204.41328C0.278906%204.41328%200%204.13438%200%203.79805Z%22%20fill%3D%22%23ECC643%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_36_660%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2242%22%20height%3D%2242%22%20fill%3D%22white%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E'
    }
  };

  // Types whose native Yotpo description text gets swapped for a shorter label.
  var descriptionOverridesByType = {
    photo: 'Add a photo to review',
    video: 'Add a video to review',
    review: 'Leave a review',
    subscription: 'Make a subscription purchase',
    instagram: 'Follow on Instagram',
    facebook: 'Follow on Facebook',
    tiktok: 'Follow on TikTok'
  };

  // Icon overrides that differ from the default settings.icons[type] lookup.
  var iconOverridesByType = {
    facebook: settings.icons.facebook,
    tiktok: settings.icons.tiktok,
    instagram: settings.icons.social
  };

  function injectStyles() {
    var oldStyle = document.getElementById('cw-yotpo-ways-redesign-css');

    if (oldStyle) {
      oldStyle.remove();
    }

    var style = document.createElement('style');
    style.id = 'cw-yotpo-ways-redesign-css';

    style.textContent = `
      body.cw-yotpo-ways-ready .cw-yotpo-hidden {
        display: none !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-loyalty-page,
      body.cw-yotpo-ways-ready .yotpo-loyalty-page-container,
      body.cw-yotpo-ways-ready .yotpo-widget-campaign-widget,
      body.cw-yotpo-ways-ready .yotpo-widget-campaign-widget-layout {
        width: 100% !important;
        background: ${settings.backgroundColor} !important;
        overflow: visible !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-loyalty-page {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-instance-container:has(.yotpo-widget-my-rewards-widget) {
        width: 100% !important;
        order: 1 !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-instance-container:has(.yotpo-widget-campaign-widget) {
        width: 100% !important;
        order: 2 !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget {
        width: 100% !important;
        max-width: 1500px !important;
        min-height: 302px !important;
        margin: 0 auto !important;
        padding: 60px 100px !important;
        background: linear-gradient(90deg, rgba(245, 239, 227, 0) 0%, ${settings.loggedInBg} 50%, rgba(245, 239, 227, 0) 100%) !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-widget-clear,
      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-background,
      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-logged-in-view {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        background: transparent !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 24px !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-headline {
        display: none !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .cw-my-rewards-headline {
        width: 100% !important;
        max-width: 561px !important;
        min-height: 46px !important;
        margin: 0 !important;
        color: ${settings.textColor} !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 42px !important;
        font-weight: 600 !important;
        line-height: 58.8px !important;
        text-align: center !important;
        text-transform: capitalize !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description {
        margin: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description .yotpo-inner-text,
      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description-points-balance .yotpo-inner-text,
      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description-tier-status .yotpo-inner-text {
        color: #E7B300 !important;
        font-family: "Open Sans", sans-serif !important;
        font-size: 24px !important;
        font-weight: 600 !important;
        line-height: 33.6px !important;
        text-align: center !important;
        text-transform: capitalize !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-vertical-divider {
        width: auto !important;
        height: auto !important;
        margin: 0 !important;
        border: 0 !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-vertical-divider::before {
        content: "|" !important;
        color: #E7B300 !important;
        font-family: "Open Sans", sans-serif !important;
        font-size: 24px !important;
        font-weight: 600 !important;
        line-height: 33.6px !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-action-buttons-tile {
        margin: 0 !important;
        padding: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 24px !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-action-button {
        width: 242px !important;
        height: 60px !important;
        min-width: 242px !important;
        min-height: 60px !important;
        margin: 0 !important;
        padding: 16px 10px !important;
        border-radius: 3px !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        line-height: 22.4px !important;
        text-transform: uppercase !important;
        text-align: center !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-primary-button {
        background: ${settings.mainColor} !important;
        border: 1px solid ${settings.mainColor} !important;
        color: #FFFFFF !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-secondary-button {
        background: transparent !important;
        border: 1px solid ${settings.mainColor} !important;
        color: ${settings.mainColor} !important;
      }

      body.cw-yotpo-ways-ready .yotpo-widget-campaign-widget-container {
        width: 100% !important;
        max-width: 1500px !important;
        margin: 0 auto !important;
        padding: 100px 20px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        gap: 60px !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .cw-yotpo-ways-header {
        width: 100% !important;
        max-width: 850px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        gap: 24px !important;
      }

      body.cw-yotpo-ways-ready .yotpo-container-headline {
        width: 100% !important;
        margin: 0 !important;
        padding: 0 !important;
        color: ${settings.mainColor} !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 42px !important;
        font-weight: 600 !important;
        line-height: 58.8px !important;
        text-align: center !important;
        text-transform: capitalize !important;
      }

      body.cw-yotpo-ways-ready .cw-yotpo-ways-subheading {
        width: 100% !important;
        margin: 0 !important;
        color: ${settings.textColor} !important;
        font-family: "Open Sans", sans-serif !important;
        font-size: 18px !important;
        font-weight: 400 !important;
        line-height: 25.2px !important;
        text-align: center !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper {
        width: 1074px !important;
        max-width: 1074px !important;
        margin: 0 auto !important;
        display: grid !important;
        grid-template-columns: repeat(3, 347px) !important;
        justify-content: center !important;
        align-items: stretch !important;
        gap: 16px !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile {
        width: 347px !important;
        max-width: 347px !important;
        height: 189px !important;
        min-height: 189px !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 1px solid ${settings.borderColor} !important;
        border-radius: 15.99px !important;
        background: ${settings.backgroundColor} !important;
        position: relative !important;
        overflow: hidden !important;
        isolation: isolate !important;
        box-sizing: border-box !important;
        cursor: pointer !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="purchase"] {
        order: 1 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="join"] {
        order: 2 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="subscription"] {
        order: 3 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="review"] {
        order: 4 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="photo"] {
        order: 5 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="video"] {
        order: 6 !important;
        grid-column: auto !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="birthday"] {
        order: 7 !important;
        grid-column: 1 !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="instagram"] {
        order: 8 !important;
        grid-column: 2 !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="facebook"] {
        order: 9 !important;
        grid-column: 3 !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="tiktok"] {
        order: 10 !important;
        grid-column: 2 !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile-group,
      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-campaign-switcher-wrapper,
      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile-wrapper {
        width: 100% !important;
        height: 100% !important;
        min-height: inherit !important;
        margin: 0 !important;
        padding: 0 !important;
        border: 0 !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile {
        width: 100% !important;
        height: 100% !important;
        min-height: 189px !important;
        padding: 24px !important;
        background: transparent !important;
        border: 0 !important;
        border-radius: 15.99px !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 15.99px !important;
        box-sizing: border-box !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-widget-campaign-widget-icon-container {
        width: 64px !important;
        height: 64px !important;
        margin: 0 !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
        background-size: contain !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-widget-campaign-widget-icon-container svg {
        opacity: 0 !important;
        visibility: hidden !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-headline-container {
        width: 100% !important;
        margin: 0 !important;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 15.99px !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-headline-center-element {
        width: 100% !important;
        margin: 0 !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 8px !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-title-text {
        width: auto !important;
        max-width: 100% !important;
        margin: 0 !important;
        color: ${settings.mainColor} !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 20px !important;
        font-weight: 600 !important;
        line-height: 24px !important;
        text-align: center !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-description-text {
        width: 100% !important;
        margin: 0 !important;
        color: ${settings.textColor} !important;
        font-family: "Open Sans", sans-serif !important;
        font-size: 16px !important;
        font-weight: 400 !important;
        line-height: 22.4px !important;
        text-align: center !important;
      }

      body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-completed-icon {
        width: 18px !important;
        min-width: 18px !important;
        height: 18px !important;
        margin: 0 !important;
        color: ${settings.mainColor} !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
      }


      body.cw-yotpo-ways-ready .cw-yotpo-redemption-source-hidden {
        display: none !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__balance {
        margin: -32px 0 0 !important;
        color: ${settings.mainColor} !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 18px !important;
        font-weight: 600 !important;
        line-height: 25.2px !important;
        text-align: center !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__balance-value {
        color: ${settings.accentColor} !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__card-action {
        width: 100% !important;
        margin-top: auto !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__native-redeem {
        width: 100% !important;
        min-width: 0 !important;
        height: 48px !important;
        min-height: 48px !important;
        margin: 0 !important;
        padding: 12px 16px !important;
        border: 1px solid ${settings.mainColor} !important;
        border-radius: 3px !important;
        background: ${settings.mainColor} !important;
        color: #FFFFFF !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        line-height: 19.6px !important;
        text-align: center !important;
        text-transform: uppercase !important;
        cursor: pointer !important;
        box-sizing: border-box !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }

      body.cw-yotpo-ways-ready .cw-points-can-become__native-redeem:disabled,
      body.cw-yotpo-ways-ready .cw-points-can-become__native-redeem[disabled],
      body.cw-yotpo-ways-ready .cw-points-can-become__native-redeem[aria-disabled="true"] {
        border-color: #9B9B9B !important;
        background: #9B9B9B !important;
        color: #FFFFFF !important;
        cursor: not-allowed !important;
        opacity: 1 !important;
      }

      @media screen and (max-width: 749px) {
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget {
          max-width: 390px !important;
          min-height: auto !important;
          padding: 45px 20px !important;
          background: linear-gradient(270deg, rgba(245, 239, 227, 0) 0%, ${settings.loggedInBg} 50%, rgba(245, 239, 227, 0) 100%) !important;
          overflow: hidden !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-widget-clear,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-background,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-logged-in-view {
          max-width: 350px !important;
          gap: 24px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .cw-my-rewards-headline {
          min-height: 46px !important;
          font-size: 26px !important;
          line-height: 36.4px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description .yotpo-inner-text,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description-points-balance .yotpo-inner-text,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-description-tier-status .yotpo-inner-text,
        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-vertical-divider::before {
          font-size: 20px !important;
          line-height: 28px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-action-buttons-tile {
          width: 342px !important;
          gap: 22px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-my-rewards-widget .yotpo-action-button {
          width: 160px !important;
          min-width: 160px !important;
          height: 52px !important;
          min-height: 52px !important;
          padding: 16px 10px !important;
          font-size: 13px !important;
          line-height: 18.2px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-widget-campaign-widget-container {
          max-width: 390px !important;
          padding: 45px 20px !important;
          gap: 35px !important;
        }

        body.cw-yotpo-ways-ready .cw-yotpo-ways-header {
          max-width: 356px !important;
          gap: 24px !important;
        }

        body.cw-yotpo-ways-ready .yotpo-container-headline {
          font-size: 26px !important;
          line-height: 36.4px !important;
        }

        body.cw-yotpo-ways-ready .cw-yotpo-ways-subheading {
          font-size: 18px !important;
          line-height: 25.2px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper {
          width: 100% !important;
          max-width: none !important;
          grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
          align-items: stretch !important;
          gap: 16px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile {
          width: 100% !important;
          max-width: none !important;
          height: auto !important;
          min-height: 154px !important;
          border-radius: 15.99px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="birthday"],
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="instagram"],
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="facebook"],
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-outer-tile[data-cw-type="tiktok"] {
          grid-column: auto !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile-group,
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-campaign-switcher-wrapper,
        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile-wrapper {
          height: 159px !important;
          min-height: 100% !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-tile {
          height: auto !important;
          min-height: 154px !important;
          padding: 15px !important;
          justify-content: center !important;
          gap: 15.99px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-widget-campaign-widget-icon-container {
          width: 42px !important;
          height: 42px !important;
          min-width: 42px !important;
          min-height: 42px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-headline-container {
          height: auto !important;
          min-height: 0 !important;
          gap: 15.99px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-headline-center-element {
          height: auto !important;
          min-height: 0 !important;
          gap: 8px !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-title-text {
          width: 100% !important;
          min-height: 0 !important;
          font-size: 16px !important;
          line-height: 19.2px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }

        body.cw-yotpo-ways-ready .campaigns-wrapper .yotpo-description-text {
          width: 100% !important;
          min-height: 0 !important;
          font-size: 13px !important;
          line-height: 18.2px !important;
          position: relative;
          bottom: 4px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function findRedemptionInstance() {
    var instances = Array.from(
      document.querySelectorAll('.yotpo-widget-instance-container')
    );

    return instances.find(function (instance) {
      if (
        instance.querySelector('.yotpo-widget-campaign-widget') ||
        instance.querySelector('.yotpo-widget-my-rewards-widget') ||
        instance.closest('.cw-points-can-become')
      ) {
        return false;
      }

      var buttons = Array.from(instance.querySelectorAll('button, a'));
      var hasRedeemButton = buttons.some(function (button) {
        return button.textContent.trim().toLowerCase().indexOf('redeem') !== -1;
      });

      var text = instance.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      var hasPointsContent = /\b\d+\s*points?\b/.test(text);

      return hasRedeemButton && hasPointsContent;
    }) || null;
  }

  function getWidgets() {
    return {
      campaign: document.querySelector('.yotpo-widget-campaign-widget'),
      rewards: document.querySelector('.yotpo-widget-my-rewards-widget'),
      redemptionInstance: findRedemptionInstance()
    };
  }

  function isolateYotpoInstances() {
    var loyaltyPage = document.querySelector('.yotpo-widget-loyalty-page');

    if (!loyaltyPage) {
      return;
    }

    loyaltyPage.querySelectorAll('.yotpo-widget-instance-container').forEach(function (instance) {
      var hasCampaign = !!instance.querySelector('.yotpo-widget-campaign-widget');
      var hasRewards = !!instance.querySelector('.yotpo-widget-my-rewards-widget');

      instance.classList.toggle('cw-yotpo-hidden', !(hasCampaign || hasRewards));
    });
  }

  function prepareHeader(campaignWidget) {
    var container = campaignWidget.querySelector('.yotpo-widget-campaign-widget-container');
    var headline = campaignWidget.querySelector('.yotpo-container-headline');

    if (!container || !headline) {
      return;
    }

    headline.textContent = settings.heading;

    var header = headline.closest('.cw-yotpo-ways-header');

    if (!header) {
      header = document.createElement('div');
      header.className = 'cw-yotpo-ways-header';

      container.insertBefore(header, headline);
      header.appendChild(headline);
    }

    var subheading = header.querySelector('.cw-yotpo-ways-subheading');

    if (!subheading) {
      subheading = document.createElement('div');
      subheading.className = 'cw-yotpo-ways-subheading';
      header.appendChild(subheading);
    }

    subheading.textContent = settings.subheading;
  }

  function getTileType(tile) {
    var text = tile.textContent.toLowerCase();
    var description = tile.querySelector('.yotpo-description-text');
    var descriptionText = description ? description.textContent.toLowerCase() : '';
    var html = tile.innerHTML.toLowerCase();

    if (descriptionText.indexOf('subscription') !== -1 || text.indexOf('subscription') !== -1) return 'subscription';
    if (descriptionText.indexOf('birthday') !== -1 || html.indexOf('birthdaycampaign') !== -1) return 'birthday';
    if (descriptionText.indexOf('video') !== -1 || html.indexOf('videocampaign') !== -1) return 'video';
    if (descriptionText.indexOf('photo') !== -1 || descriptionText.indexOf('image') !== -1 || html.indexOf('imagecampaign') !== -1) return 'photo';
    if (descriptionText.indexOf('leave a review') !== -1 || html.indexOf('yotporeviewcampaign') !== -1) return 'review';
    if (descriptionText.indexOf('instagram') !== -1 || html.indexOf('instagram') !== -1) return 'instagram';
    if (descriptionText.indexOf('tiktok') !== -1 || text.indexOf('tiktok') !== -1) return 'tiktok';
    if (descriptionText.indexOf('facebook') !== -1 || text.indexOf('facebook') !== -1) return 'facebook';
    if (descriptionText.indexOf('join') !== -1 || html.indexOf('createaccountcampaign') !== -1) return 'join';
    if (descriptionText.indexOf('purchase') !== -1 || text.indexOf('purchase') !== -1) return 'purchase';

    return 'social';
  }

  function getIconUrl(type) {
    return iconOverridesByType[type] || settings.icons[type] || settings.icons.social;
  }

  function updateTileDescription(tile, type) {
    var description = tile.querySelector('.yotpo-description-text');
    var replacement = descriptionOverridesByType[type];

    if (description && replacement) {
      description.textContent = replacement;
    }
  }

  function replaceIcon(tile, type) {
    var iconContainer = tile.querySelector('.yotpo-widget-campaign-widget-icon-container');

    if (iconContainer) {
      iconContainer.style.backgroundImage = 'url("' + getIconUrl(type) + '")';
    }
  }

  function prepareCards(campaignWidget) {
    var tiles = campaignWidget.querySelectorAll('.campaigns-wrapper .yotpo-outer-tile');

    tiles.forEach(function (tile) {
      var type = getTileType(tile);

      tile.dataset.cwType = type;

      updateTileDescription(tile, type);
      replaceIcon(tile, type);
    });
  }

  function prepareRewardsWidget(rewardsWidget) {
    if (!rewardsWidget) {
      return;
    }

    var loggedInView = rewardsWidget.querySelector('.yotpo-logged-in-view');

    if (!loggedInView || loggedInView.getClientRects().length === 0) {
      return;
    }

    var loggedInStyles = window.getComputedStyle(loggedInView);

    if (
      loggedInStyles.display === 'none' ||
      loggedInStyles.visibility === 'hidden' ||
      loggedInStyles.opacity === '0'
    ) {
      return;
    }

    var nativeHeadline = rewardsWidget.querySelector('.yotpo-headline');

    if (nativeHeadline) {
      nativeHeadline.style.display = 'none';
    }

    var customHeadline = rewardsWidget.querySelector('.cw-my-rewards-headline');

    if (!customHeadline) {
      customHeadline = document.createElement('div');
      customHeadline.className = 'cw-my-rewards-headline';
      loggedInView.insertBefore(customHeadline, loggedInView.firstChild);
    }

    customHeadline.textContent = 'Hey there!';

    var primaryButton = rewardsWidget.querySelector('.yotpo-primary-button');
    var secondaryButton = rewardsWidget.querySelector('.yotpo-secondary-button');

    if (primaryButton) {
      primaryButton.textContent = 'Redeem my points';
    }

    if (secondaryButton) {
      secondaryButton.textContent = 'Rewards history';
    }

    var rewardsStepsSection = document.getElementById(
      'cw-rewards-steps-template--22782640718132__cw_three_steps_kf9pTG'
    );

    if (!rewardsStepsSection) {
      return;
    }

    var rewardsStepsInner = rewardsStepsSection.querySelector(
      '.cw-rewards-steps__inner'
    );

    if (
      !rewardsStepsInner ||
      rewardsStepsInner.dataset.cwLoggedInContent === 'true'
    ) {
      return;
    }

    rewardsStepsInner.innerHTML = '';
    rewardsStepsInner.appendChild(rewardsWidget);
    rewardsStepsInner.dataset.cwLoggedInContent = 'true';

    rewardsWidget.style.setProperty('background', 'transparent', 'important');
    rewardsWidget.style.setProperty('max-width', 'none', 'important');
    rewardsWidget.style.setProperty('min-height', 'auto', 'important');
    rewardsWidget.style.setProperty('padding', '0', 'important');
  }

  function getRewardTileFromButton(button, root) {
    var node = button;

    while (node && node !== root) {
      var text = node.textContent.replace(/\s+/g, ' ').trim().toLowerCase();

      if (
        /\b\d+\s*points?\b/.test(text) &&
        text.indexOf('redeem') !== -1
      ) {
        return node;
      }

      node = node.parentElement;
    }

    return button.parentElement;
  }

  function getRewardData(tile, button) {
    var normalizedText = tile.textContent.replace(/\s+/g, ' ').trim();
    var pointsMatch = normalizedText.match(/\b\d[\d,]*\s*points?\b/i);
    var moneyMatch = normalizedText.match(/\$\s*\d+(?:\.\d{1,2})?\s*(?:off)?/i);

    var title = moneyMatch ? moneyMatch[0].replace(/\s+/g, ' ').trim() : '';
    var points = pointsMatch ? pointsMatch[0].replace(/\s+/g, ' ').trim() : '';

    if (title && /\boff\b/i.test(title)) {
      title = title.replace(/\s+your\s+next\s+order$/i, '') + ' your next order';
    }

    if (!title) {
      var textElements = Array.from(
        tile.querySelectorAll('h1, h2, h3, h4, h5, h6, strong, b, [class*="title"], [class*="headline"]')
      );

      var titleElement = textElements.find(function (element) {
        var text = element.textContent.replace(/\s+/g, ' ').trim();

        return (
          text &&
          text.toLowerCase().indexOf('redeem') === -1 &&
          !/\b\d+\s*points?\b/i.test(text)
        );
      });

      title = titleElement ? titleElement.textContent.replace(/\s+/g, ' ').trim() : '';
    }

    return {
      title: title,
      points: points,
      button: button
    };
  }

  function collectRewardOptions(redemptionInstance) {
    if (!redemptionInstance) {
      return [];
    }

    var buttons = Array.from(
      redemptionInstance.querySelectorAll('button, a')
    ).filter(function (button) {
      return button.textContent.trim().toLowerCase().indexOf('redeem') !== -1;
    });

    var seenTiles = new Set();

    return buttons.reduce(function (options, button) {
      var tile = getRewardTileFromButton(button, redemptionInstance);

      if (!tile || seenTiles.has(tile)) {
        return options;
      }

      seenTiles.add(tile);

      var reward = getRewardData(tile, button);

      if (reward.points) {
        options.push(reward);
      }

      return options;
    }, []);
  }

  function updatePointsBalance(targetSection, rewardsWidget) {
    var balanceTarget = targetSection.querySelector(
      '.cw-points-can-become__balance-value'
    );

    if (!balanceTarget || !rewardsWidget) {
      return;
    }

    var balanceSource = rewardsWidget.querySelector(
      '.yotpo-description-points-balance .yotpo-inner-text'
    );

    if (!balanceSource) {
      return;
    }

    var balanceMatch = balanceSource.textContent.match(/\d[\d,]*/);

    if (balanceMatch) {
      balanceTarget.textContent = balanceMatch[0];
    }
  }

  function prepareRedemptionWidget(redemptionInstance, rewardsWidget) {
    var targetSection = document.querySelector(
      '.cw-points-can-become[data-cw-yotpo-redemption-target="true"]'
    );

    if (!targetSection || !redemptionInstance) {
      return false;
    }

    var rewardOptions = collectRewardOptions(redemptionInstance);
    var targetCards = Array.from(
      targetSection.querySelectorAll('.cw-points-can-become__card')
    );

    if (!rewardOptions.length || !targetCards.length) {
      return false;
    }

    targetCards.forEach(function (card, index) {
      var reward = rewardOptions[index];
      var title = card.querySelector('.cw-points-can-become__card-title');
      var points = card.querySelector('.cw-points-can-become__points');
      var action = card.querySelector('.cw-points-can-become__card-action');

      if (!reward) {
        card.style.display = 'none';
        return;
      }

      card.style.removeProperty('display');

      if (title && reward.title) {
        title.textContent = reward.title;
      }

      if (points && reward.points) {
        points.textContent = reward.points;
      }

      if (action && !action.contains(reward.button)) {
        action.innerHTML = '';
        reward.button.classList.add('cw-points-can-become__native-redeem');
        action.appendChild(reward.button);
      }
    });

    updatePointsBalance(targetSection, rewardsWidget);

    redemptionInstance.classList.add('cw-yotpo-redemption-source-hidden');
    targetSection.dataset.cwYotpoReady = 'true';

    return true;
  }

  function run() {
    var widgets = getWidgets();

    if (!widgets.campaign) {
      return false;
    }

    injectStyles();
    isolateYotpoInstances();
    prepareHeader(widgets.campaign);
    prepareCards(widgets.campaign);
    prepareRewardsWidget(widgets.rewards);

    document.body.classList.add('cw-yotpo-ways-ready');

    return true;
  }

  function init() {
    var attempts = 0;
    var maxAttempts = 100;

    var interval = window.setInterval(function () {
      attempts += 1;

      var done = run();

      if (done || attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 250);

    window.setTimeout(run, 1500);
    window.setTimeout(run, 3000);
    window.setTimeout(run, 5000);

    window.addEventListener('load', run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* =========================================================================
 * SCRIPT 2 — "What Your Points Can Become" redemption cards section
 * ========================================================================= */
(function () {
  var CONFIG = {
    sectionId: 'cw-yotpo-redemption-rendered',
    styleId: 'cw-yotpo-redemption-rendered-css',
    mainColor: '#09152B',
    textColor: '#666666',
    accentColor: '#ECC643',
    backgroundColor: '#F5EFE3',
    cardBackground: 'rgba(255, 255, 255, 0.18)',
    borderColor: '#09152B',
    heading: 'What Your Points Can Become.',
    conversionText: '',
    description:
      'Redeeming your points is easy! Just click Redeem my points, and select an eligible reward.',
    icons: [
      `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <path d="M26.6347 18.7252C26.3071 18.3976 25.7746 18.3976 25.447 18.7252L15.367 28.8052C15.0394 29.1328 15.0394 29.6654 15.367 29.993C15.5299 30.1576 15.745 30.2399 15.96 30.2399C16.1751 30.2399 16.3901 30.1576 16.5547 29.9946L26.6347 19.9146C26.9623 19.5854 26.9623 19.0545 26.6347 18.7252Z" fill="#09152B"/>
        <path d="M19.32 20.9999C19.32 19.1469 17.813 17.6399 15.96 17.6399C14.107 17.6399 12.6 19.1469 12.6 20.9999C12.6 22.8529 14.107 24.3599 15.96 24.3599C17.813 24.3599 19.32 22.8529 19.32 20.9999ZM14.28 20.9999C14.28 20.0725 15.0343 19.3199 15.96 19.3199C16.8857 19.3199 17.64 20.0725 17.64 20.9999C17.64 21.9273 16.8857 22.6799 15.96 22.6799C15.0343 22.6799 14.28 21.9273 14.28 20.9999Z" fill="#09152B"/>
        <path d="M26.04 24.3599C24.187 24.3599 22.68 25.8668 22.68 27.7199C22.68 29.5729 24.187 31.0799 26.04 31.0799C27.8931 31.0799 29.4 29.5729 29.4 27.7199C29.4 25.8668 27.8931 24.3599 26.04 24.3599ZM26.04 29.3999C25.1143 29.3999 24.36 28.6472 24.36 27.7199C24.36 26.7925 25.1143 26.0399 26.04 26.0399C26.9657 26.0399 27.72 26.7925 27.72 27.7199C27.72 28.6472 26.9657 29.3999 26.04 29.3999Z" fill="#09152B"/>
        <path d="M33.6 10.92H28.513C28.093 7.14499 24.8842 4.19995 21 4.19995C17.1159 4.19995 13.9054 7.14499 13.4871 10.92H8.40001C6.08497 10.92 4.20001 12.8032 4.20001 15.12V33.6C4.20001 35.9167 6.08497 37.8 8.40001 37.8H33.6C35.9151 37.8 37.8 35.9167 37.8 33.6V15.12C37.8 12.8032 35.9151 10.92 33.6 10.92ZM36.12 33.6C36.12 34.9893 34.9894 36.12 33.6 36.12H8.40001C7.01065 36.12 5.88001 34.9893 5.88001 33.6V15.12C5.88001 13.7306 7.01065 12.6 8.40001 12.6H14.28C14.7437 12.6 15.12 12.2236 15.12 11.76C15.12 8.51755 17.7576 5.87995 21 5.87995C24.2424 5.87995 26.88 8.51755 26.88 11.76C26.88 12.2236 27.2563 12.6 27.72 12.6H33.6C34.9894 12.6 36.12 13.7306 36.12 15.12V33.6Z" fill="#09152B"/>
        <path d="M21 11.7598C21.4639 11.7598 21.84 11.3838 21.84 10.9198C21.84 10.4559 21.4639 10.0798 21 10.0798C20.5361 10.0798 20.16 10.4559 20.16 10.9198C20.16 11.3838 20.5361 11.7598 21 11.7598Z" fill="#09152B"/>
      </svg>`,
      `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <path d="M19.6875 16.4062C19.6875 15.7573 19.495 15.1229 19.1345 14.5833C18.7739 14.0437 18.2615 13.6231 17.6619 13.3748C17.0623 13.1264 16.4026 13.0614 15.7661 13.188C15.1296 13.3147 14.5449 13.6272 14.086 14.0861C13.6271 14.5449 13.3146 15.1296 13.188 15.7661C13.0614 16.4026 13.1264 17.0624 13.3748 17.6619C13.6231 18.2615 14.0437 18.774 14.5833 19.1345C15.1229 19.4951 15.7573 19.6875 16.4062 19.6875C17.2762 19.6865 18.1102 19.3404 18.7253 18.7253C19.3404 18.1102 19.6864 17.2762 19.6875 16.4062ZM14.4375 16.4062C14.4375 16.0169 14.5529 15.6362 14.7693 15.3125C14.9856 14.9887 15.2931 14.7364 15.6528 14.5874C16.0126 14.4384 16.4084 14.3994 16.7903 14.4753C17.1722 14.5513 17.523 14.7388 17.7984 15.0141C18.0737 15.2895 18.2612 15.6403 18.3372 16.0222C18.4131 16.4041 18.3741 16.7999 18.2251 17.1597C18.0761 17.5194 17.8238 17.8269 17.5 18.0432C17.1763 18.2595 16.7956 18.375 16.4062 18.375C15.8841 18.375 15.3833 18.1676 15.0141 17.7984C14.6449 17.4292 14.4375 16.9284 14.4375 16.4062ZM25.5937 22.3125C24.9448 22.3125 24.3104 22.5049 23.7708 22.8655C23.2312 23.226 22.8106 23.7385 22.5623 24.3381C22.3139 24.9376 22.2489 25.5974 22.3755 26.2339C22.5021 26.8704 22.8147 27.4551 23.2735 27.9139C23.7324 28.3728 24.3171 28.6853 24.9536 28.812C25.5901 28.9386 26.2498 28.8736 26.8494 28.6252C27.449 28.3769 27.9615 27.9563 28.322 27.4167C28.6825 26.8771 28.875 26.2427 28.875 25.5938C28.8739 24.7238 28.5279 23.8898 27.9128 23.2747C27.2977 22.6596 26.4637 22.3135 25.5937 22.3125ZM25.5937 27.5625C25.2044 27.5625 24.8237 27.447 24.5 27.2307C24.1762 27.0144 23.9239 26.7069 23.7749 26.3472C23.6258 25.9874 23.5869 25.5916 23.6628 25.2097C23.7388 24.8278 23.9263 24.477 24.2016 24.2016C24.477 23.9263 24.8278 23.7388 25.2097 23.6628C25.5916 23.5869 25.9874 23.6259 26.3471 23.7749C26.7069 23.9239 27.0144 24.1762 27.2307 24.5C27.447 24.8237 27.5625 25.2044 27.5625 25.5938C27.5625 26.1159 27.3551 26.6167 26.9859 26.9859C26.6166 27.3551 26.1159 27.5625 25.5937 27.5625ZM39.1361 16.4929C39.5767 16.4012 39.9719 16.1598 40.2547 15.8098C40.5375 15.4598 40.6904 15.0227 40.6875 14.5727V10.5C40.6865 9.63008 40.3404 8.79608 39.7253 8.18096C39.1102 7.56583 38.2762 7.21979 37.4062 7.21875H4.59373C3.72381 7.21979 2.88982 7.56583 2.27469 8.18096C1.65956 8.79608 1.31352 9.63008 1.31248 10.5V14.5727C1.30956 15.0227 1.46248 15.4598 1.74528 15.8098C2.02807 16.1598 2.42331 16.4012 2.86386 16.4929C3.90803 16.6986 4.84839 17.2604 5.52429 18.0825C6.20019 18.9045 6.56971 19.9358 6.56971 21C6.56971 22.0642 6.20019 23.0955 5.52429 23.9175C4.84839 24.7396 3.90803 25.3014 2.86386 25.5071C2.42331 25.5988 2.02807 25.8402 1.74528 26.1902C1.46248 26.5402 1.30956 26.9773 1.31248 27.4273V31.5C1.31352 32.3699 1.65956 33.2039 2.27469 33.819C2.88982 34.4342 3.72381 34.7802 4.59373 34.7812H37.4062C38.2762 34.7802 39.1102 34.4342 39.7253 33.819C40.3404 33.2039 40.6865 32.3699 40.6875 31.5V27.4273C40.6904 26.9773 40.5375 26.5402 40.2547 26.1902C39.9719 25.8402 39.5767 25.5988 39.1361 25.5071C38.0919 25.3014 37.1516 24.7396 36.4757 23.9175C35.7998 23.0955 35.4303 22.0642 35.4303 21C35.4303 19.9358 35.7998 18.9045 36.4757 18.0825C37.1516 17.2604 38.0919 16.6986 39.1361 16.4929ZM34.125 21C34.1267 22.3667 34.6014 23.6906 35.4686 24.747C36.3358 25.8033 37.542 26.5268 38.8821 26.7947C39.0247 26.8269 39.1518 26.9076 39.2416 27.0229C39.3315 27.1383 39.3786 27.2812 39.375 27.4273V31.5C39.375 32.0221 39.1676 32.5229 38.7984 32.8921C38.4291 33.2613 37.9284 33.4688 37.4062 33.4688H4.59373C4.07159 33.4688 3.57083 33.2613 3.20161 32.8921C2.8324 32.5229 2.62498 32.0221 2.62498 31.5V27.4273C2.6215 27.2812 2.66868 27.1384 2.75851 27.0231C2.84834 26.9077 2.97529 26.8271 3.11782 26.7947C4.46013 26.53 5.66891 25.8076 6.53774 24.7507C7.40657 23.6939 7.88154 22.3681 7.88154 21C7.88154 19.6319 7.40657 18.3061 6.53774 17.2493C5.66891 16.1924 4.46013 15.47 3.11782 15.2053C2.97529 15.1729 2.84834 15.0923 2.75851 14.977C2.66868 14.8616 2.6215 14.7188 2.62498 14.5727V10.5C2.62498 9.97785 2.8324 9.4771 3.20161 9.10788C3.57083 8.73867 4.07159 8.53125 4.59373 8.53125H37.4062C37.9284 8.53125 38.4291 8.73867 38.7984 9.10788C39.1676 9.4771 39.375 9.97785 39.375 10.5V14.5727C39.3786 14.7188 39.3315 14.8617 39.2416 14.9771C39.1518 15.0924 39.0247 15.1731 38.8821 15.2053C37.542 15.4732 36.3358 16.1967 35.4686 17.253C34.6014 18.3094 34.1267 19.6333 34.125 21ZM27.3702 15.5577L15.5577 27.3702C15.4339 27.4898 15.2682 27.5559 15.0961 27.5544C14.924 27.5529 14.7594 27.4839 14.6378 27.3622C14.5161 27.2406 14.4471 27.076 14.4456 26.9039C14.4441 26.7318 14.5102 26.5661 14.6298 26.4423L26.4423 14.6298C26.566 14.5102 26.7318 14.4441 26.9039 14.4456C27.0759 14.4471 27.2405 14.5161 27.3622 14.6378C27.4839 14.7594 27.5529 14.924 27.5544 15.0961C27.5559 15.2682 27.4897 15.4339 27.3702 15.5577Z" fill="#09152B"/>
      </svg>`,
      `<svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <g clip-path="url(#cw-redemption-clip)">
          <path d="M21 0C19.8422 0 18.9 0.9422 18.9 2.1V2.8H16.646C15.7843 2.8 14.917 3.0772 14.2016 3.5812L8.7549 7.4809C7.6566 8.2698 7 9.5473 7 10.899V37.8C7 40.1163 8.8837 42 11.2 42H30.8C33.1163 42 35 40.1163 35 37.8V10.899C35 9.5473 34.3434 8.2698 33.2444 7.4802L27.7942 3.5784C27.0823 3.0765 26.2157 2.8 25.354 2.8H23.1V2.1C23.1 0.9422 22.1578 0 21 0ZM23.1 9.8C23.1 10.9578 22.1578 11.9 21 11.9C19.8422 11.9 18.9 10.9578 18.9 9.8C18.9 9.5599 18.9546 9.331 19.0323 9.1105C19.3249 9.9183 20.0928 10.5 21 10.5C21.9072 10.5 22.6751 9.9183 22.9677 9.1112C23.0454 9.3317 23.1 9.5606 23.1 9.8ZM20.3 2.1C20.3 1.7136 20.6136 1.4 21 1.4C21.3864 1.4 21.7 1.7136 21.7 2.1V8.4C21.7 8.7864 21.3864 9.1 21 9.1C20.6136 9.1 20.3 8.7864 20.3 8.4V2.1ZM25.354 4.2C25.9294 4.2 26.5097 4.3862 26.9836 4.7201L32.4289 8.6184C33.1625 9.1448 33.6 9.9974 33.6 10.899V37.8C33.6 39.3442 32.3442 40.6 30.8 40.6H11.2C9.6558 40.6 8.4 39.3442 8.4 37.8V10.899C8.4 9.9974 8.8375 9.1448 9.5704 8.6191L15.0122 4.7229C15.4903 4.3862 16.0706 4.2 16.646 4.2H18.9V7.0056C18.0285 7.6601 17.5 8.6954 17.5 9.8C17.5 11.7299 19.0701 13.3 21 13.3C22.9299 13.3 24.5 11.7299 24.5 9.8C24.5 8.6947 23.9715 7.6594 23.1 7.0056V4.2H25.354Z" fill="#09152B"/>
          <path d="M13.5051 33.3948C13.6416 33.5313 13.8208 33.5999 14 33.5999C14.1792 33.5999 14.3584 33.5313 14.4949 33.3948L28.4949 19.3948C28.7686 19.1211 28.7686 18.6787 28.4949 18.405C28.2212 18.1313 27.7788 18.1313 27.5051 18.405L13.5051 32.405C13.2314 32.6787 13.2314 33.1211 13.5051 33.3948Z" fill="#09152B"/>
          <path d="M16.8 25.2C18.7299 25.2 20.3 23.6299 20.3 21.7C20.3 19.7701 18.7299 18.2 16.8 18.2C14.8701 18.2 13.3 19.7701 13.3 21.7C13.3 23.6299 14.8701 25.2 16.8 25.2ZM16.8 19.6C17.9578 19.6 18.9 20.5422 18.9 21.7C18.9 22.8578 17.9578 23.8 16.8 23.8C15.6422 23.8 14.7 22.8578 14.7 21.7C14.7 20.5422 15.6422 19.6 16.8 19.6Z" fill="#09152B"/>
          <path d="M25.2 26.6001C23.2701 26.6001 21.7 28.1702 21.7 30.1001C21.7 32.03 23.2701 33.6001 25.2 33.6001C27.1299 33.6001 28.7 32.03 28.7 30.1001C28.7 28.1702 27.1299 26.6001 25.2 26.6001ZM25.2 32.2001C24.0422 32.2001 23.1 31.2579 23.1 30.1001C23.1 28.9423 24.0422 28.0001 25.2 28.0001C26.3578 28.0001 27.3 28.9423 27.3 30.1001C27.3 31.2579 26.3578 32.2001 25.2 32.2001Z" fill="#09152B"/>
        </g>
        <defs>
          <clipPath id="cw-redemption-clip">
            <rect width="42" height="42" fill="white"/>
          </clipPath>
        </defs>
      </svg>`
    ]
  };

  // Shared matchers used across several lookup helpers below.
  var POINTS_PATTERN = /\b\d[\d,]*\s*points?\b/i;
  var MONEY_PATTERN = /\$\s*\d+(?:\.\d{1,2})?\s*(?:off)?/i;

  var observer = null;
  var updateQueued = false;

  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var styles = window.getComputedStyle(element);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0' &&
      element.getClientRects().length > 0
    );
  }

  function isCustomerLoggedIn() {
    var loggedInView = document.querySelector(
      '.yotpo-widget-my-rewards-widget .yotpo-logged-in-view'
    );

    var pointsBalance = document.querySelector(
      '.yotpo-description-points-balance .yotpo-inner-text'
    );

    var rewardsButton = document.querySelector(
      '.yotpo-widget-my-rewards-widget .yotpo-primary-button'
    );

    return (
      isVisible(loggedInView) ||
      !!pointsBalance ||
      !!rewardsButton
    );
  }

  function isRewardsPage() {
    var path = window.location.pathname.replace(/\/$/, '');

    if (path === '/pages/rewards') {
      return true;
    }

    var params = new URLSearchParams(window.location.search);
    var previewPath = params.get('previewPath');

    return (
      previewPath &&
      previewPath.replace(/\/$/, '') === '/pages/rewards'
    );
  }

  function injectStyles() {
    if (document.getElementById(CONFIG.styleId)) {
      return;
    }

    var style = document.createElement('style');
    style.id = CONFIG.styleId;
    style.textContent = `
      #${CONFIG.sectionId} {
        width: 100%;
        order: 3 !important;
        background: linear-gradient(
          90deg,
          rgba(245, 239, 227, 0) 0%,
          ${CONFIG.backgroundColor} 50%,
          rgba(245, 239, 227, 0) 100%
        );
        overflow: hidden;
      }

      #${CONFIG.sectionId} * {
        box-sizing: border-box;
      }

      #${CONFIG.sectionId} .cw-redemption__inner {
        width: 100%;
        max-width: 1500px;
        margin: 0 auto;
        padding: 90px 100px 100px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 34px;
      }

      #${CONFIG.sectionId} .cw-redemption__header {
        width: 100%;
        max-width: 850px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
      }

      #${CONFIG.sectionId} .cw-redemption__heading {
        margin: 0;
        color: ${CONFIG.mainColor};
        font-family: Montserrat, sans-serif;
        font-size: 42px;
        font-weight: 600;
        line-height: 1.25;
        text-align: center;
      }

      #${CONFIG.sectionId} .cw-redemption__conversion {
        display: none;
      }

      #${CONFIG.sectionId} .cw-redemption__description {
        max-width: 700px;
        margin: 0;
        color: ${CONFIG.textColor};
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.4;
        text-align: center;
      }

      #${CONFIG.sectionId} .cw-redemption__balance {
        display: block;
        width: 100%;
        margin: 0;
        color: ${CONFIG.mainColor};
        font-family: Montserrat, sans-serif;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.4;
        text-align: center;
      }

      #${CONFIG.sectionId} .cw-redemption__balance-value {
        color: inherit;
      }

      #${CONFIG.sectionId} .cw-redemption__cards {
        width: 100%;
        max-width: 1058px;
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 16px;
      }

      #${CONFIG.sectionId} .cw-redemption__card {
        min-height: 220px;
        padding: 24px 30px 22px;
        border: 1px solid ${CONFIG.borderColor};
        border-radius: 12px;
        background: ${CONFIG.cardBackground};
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
      }

      #${CONFIG.sectionId} .cw-redemption__icon {
        width: 42px;
        height: 42px;
        margin-bottom: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      #${CONFIG.sectionId} .cw-redemption__icon svg {
        width: 42px;
        height: 42px;
        display: block;
      }

      #${CONFIG.sectionId} .cw-redemption__title {
        margin: 0;
        color: ${CONFIG.mainColor};
        font-family: Montserrat, sans-serif;
        font-size: 20px;
        font-weight: 600;
        line-height: 1.2;
        text-align: center;
      }

      #${CONFIG.sectionId} .cw-redemption__points {
        margin: 3px 0 18px;
        color: ${CONFIG.textColor};
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 1.4;
        text-align: center;
       
      }

      #${CONFIG.sectionId} .cw-redemption__action {
        width: 100%;
        margin-top: auto;
      }

      #${CONFIG.sectionId} .cw-redemption__button {
        width: 100% !important;
        min-width: 0 !important;
        height: 48px !important;
        min-height: 48px !important;
        margin: 0 !important;
        padding: 12px 16px !important;
        border: 1px solid ${CONFIG.mainColor} !important;
        border-radius: 3px !important;
        background: ${CONFIG.mainColor} !important;
        color: #FFFFFF !important;
        font-family: Montserrat, sans-serif !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        line-height: 1.2 !important;
        text-align: center !important;
        text-transform: uppercase !important;
        text-decoration: none !important;
        cursor: pointer !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-sizing: border-box !important;
        /*
          The real Yotpo redeem button reads its own typography from these
          CSS custom properties (set inline by Yotpo itself). Overriding them
          here too makes sure our font-size/weight/family win even if Yotpo's
          internal rule references var(--font-size) instead of a literal value.
        */
        --font-family: Montserrat, sans-serif !important;
        --font-size: 14px !important;
        --font-weight: 600 !important;
        --text-color: #FFFFFF !important;
      }

      #${CONFIG.sectionId} .cw-redemption__button .yotpo-button-label {
        font-size: inherit !important;
        font-family: inherit !important;
        font-weight: inherit !important;
        line-height: inherit !important;
        color: inherit !important;
      }

      #${CONFIG.sectionId} .cw-redemption__button:disabled,
      #${CONFIG.sectionId} .cw-redemption__button[disabled],
      #${CONFIG.sectionId} .cw-redemption__button[aria-disabled="true"] {
        border-color: #9B9B9B !important;
        background: #9B9B9B !important;
        color: #FFFFFF !important;
        cursor: not-allowed !important;
        opacity: 1 !important;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__cards {
        max-width: 1094px;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__card {
        width: 100%;
        min-width: 0;
        min-height: 173px;
        padding: 24px;
        border-radius: 15.99px;
        background: #F7F6F2;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 16px;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__icon {
        width: 54.97px;
        height: 54.97px;
        margin: 0;
        padding-left: 2px;
        justify-content: flex-start;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__icon svg {
        width: 42px;
        height: 42px;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__title {
        width: 100%;
        margin: 0;
        font-size: 20px;
        line-height: 24px;
        text-align: left;
      }

      #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__points {
        width: 100%;
        margin: 8px 0 0;
        color: ${CONFIG.textColor};
        font-size: 16px;
        line-height: 22.4px;
        text-align: left;
      }

      #${CONFIG.sectionId} .cw-redemption__logged-out-cta {
        width: 242px;
        height: 60px;
        margin: 16px auto 0;
        padding: 16px 10px;
        border-radius: 3px;
        background: ${CONFIG.mainColor};
        color: #FFFFFF;
        font-family: Montserrat, sans-serif;
        font-size: 16px;
        font-weight: 600;
        line-height: 22.4px;
        text-align: center;
        text-transform: uppercase;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        box-sizing: border-box;
      }

      .cw-yotpo-redemption-source-hidden {
        display: none !important;
      }

      @media screen and (max-width: 749px) {
        #${CONFIG.sectionId} {
          background: linear-gradient(
            270deg,
            rgba(245, 239, 227, 0) 0%,
            ${CONFIG.backgroundColor} 50%,
            rgba(245, 239, 227, 0) 100%
          );
        }

        #${CONFIG.sectionId} .cw-redemption__inner {
          max-width: 390px;
          padding: 45px 20px;
          gap: 28px;
        }

        #${CONFIG.sectionId} .cw-redemption__header {
          max-width: 350px;
          gap: 10px;
        }

        #${CONFIG.sectionId} .cw-redemption__heading {
          font-size: 26px;
          line-height: 1.3;
        }

        #${CONFIG.sectionId} .cw-redemption__conversion {
          font-size: 17px;
        }

        #${CONFIG.sectionId} .cw-redemption__description {
          font-size: 16px;
          line-height: 1.4;
        }

        #${CONFIG.sectionId} .cw-redemption__balance {
          font-size: 16px;
        }

        #${CONFIG.sectionId} .cw-redemption__cards {
          width: 100%;
          max-width: none;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          justify-content: center;
          gap: 16px;
        }

        #${CONFIG.sectionId} .cw-redemption__card {
          width: 100%;
          min-width: 0;
          min-height: 171px;
          padding: 15px;
          border-radius: 15.99px;
          align-items: flex-start;
          gap: 16px;
        }

        #${CONFIG.sectionId} .cw-redemption__card:last-child:nth-child(odd) {
          grid-column: 1 / -1;
          width: calc((100% - 16px) / 2);
          justify-self: center;
        }

        /*
          Logged-in card look, mobile only (excludes .cw-redemption--logged-out,
          which has its own dedicated styling further up). Matches the design
          spec: 12px vertical / 15px horizontal padding, 12px internal gap,
          #F7F6F2 fill, and a 1px black outline instead of a border so the
          rounded corners stay clean.
        */
        #${CONFIG.sectionId}:not(.cw-redemption--logged-out) .cw-redemption__card {
          min-height: 210px;
          gap: 12px;
          background: #F7F6F2;
          border: none;
          outline: 1px solid #000000;
          outline-offset: -1px;
        }

        #${CONFIG.sectionId}:not(.cw-redemption--logged-out) .cw-redemption__icon {
          border-radius: 8px;
          overflow: hidden;
        }

        /*
          Same card treatment as above, mirrored for the logged-out
          placeholder cards. Intentionally does NOT touch the CTA
          (.cw-redemption__logged-out-cta) -- only the card shell/icon.
        */
        #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__card {
          gap: 12px;
          background: #F7F6F2;
          border: none;
          outline: 1px solid #000000;
          outline-offset: -1px;
        }

        #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__icon {
          border-radius: 8px;
          overflow: hidden;
        }

        #${CONFIG.sectionId} .cw-redemption__icon {
          width: 54.97px;
          height: 54.97px;
          margin-bottom: 0;
          padding-left: 2px;
          justify-content: flex-start;
        }

        #${CONFIG.sectionId} .cw-redemption__icon svg {
          width: 32px;
          height: 32px;
        }

        #${CONFIG.sectionId} .cw-redemption__title {
          width: 100%;
          font-size: 16px;
          line-height: 19.2px;
          text-align: left;
        }

        /*
          The desktop rule for .cw-redemption--logged-out .cw-redemption__title
          (font-size: 20px) is more specific than the generic mobile rule above,
          so it wins on mobile too unless we re-target it here. This restores
          the intended 16px mobile size so the title wraps naturally instead of
          forcing an oversized 3-line break.
        */
        #${CONFIG.sectionId}.cw-redemption--logged-out .cw-redemption__title {
          font-size: 16px;
          line-height: 19.2px;
        }

        #${CONFIG.sectionId} .cw-redemption__points {
          width: 100%;
          margin: 0 0 12px;
          font-size: 14px;
          line-height: 19.6px;
          text-align: left;
        }

        #${CONFIG.sectionId} .cw-redemption__action {
          margin-top: auto;
        }

        /*
          Logged-in CTA on mobile: smaller, muted grey pill instead of the
          full-size navy button used on desktop.
        */
        #${CONFIG.sectionId} .cw-redemption__button {
          height: 37px !important;
          min-height: 37px !important;
          padding: 16px 10px !important;
          background: #95989C !important;
          border-color: #95989C !important;
          font-size: 11px !important;
          line-height: 15.4px !important;
          gap: 10px !important;
          --font-size: 11px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function findRewardsWidget() {
    var widgets = Array.from(
      document.querySelectorAll('.yotpo-widget-my-rewards-widget')
    );

    return widgets.find(function (widget) {
      return !!widget.querySelector('.yotpo-logged-in-view');
    }) || null;
  }

  function findRewardTile(button, root) {
    var node = button;

    while (node && node !== root) {
      var text = normalizeText(node.textContent).toLowerCase();

      if (text.includes('redeem') && POINTS_PATTERN.test(text)) {
        return node;
      }

      node = node.parentElement;
    }

    return button.parentElement;
  }

  function findRedemptionSource() {
    var buttons = Array.from(
      document.querySelectorAll(
        '.yotpo-widget-instance-container button, .yotpo-widget-instance-container a'
      )
    ).filter(function (button) {
      return normalizeText(button.textContent)
        .toLowerCase()
        .includes('redeem');
    });

    var redeemButton = buttons.find(function (button) {
      var instance = button.closest('.yotpo-widget-instance-container');

      if (
        !instance ||
        instance.querySelector('.yotpo-widget-campaign-widget') ||
        instance.querySelector('.yotpo-widget-my-rewards-widget') ||
        instance.closest('#' + CONFIG.sectionId)
      ) {
        return false;
      }

      var tile = findRewardTile(button, instance);
      var text = normalizeText(tile ? tile.textContent : '');

      return POINTS_PATTERN.test(text);
    });

    if (!redeemButton) {
      return null;
    }

    var instance = redeemButton.closest('.yotpo-widget-instance-container');

    return {
      instance: instance,
      root:
        redeemButton.closest(
          '.yotpo-redemption-widget, .yotpo-widget-redemption-widget, .yotpo-reward-options-list, .yotpo-rewards-list, .yotpo-widget-redemption'
        ) || instance
    };
  }

  function readRewardData(tile, button) {
    var text = normalizeText(tile.textContent);
    var pointsMatch = text.match(POINTS_PATTERN);
    var moneyMatch = text.match(MONEY_PATTERN);

    var title = moneyMatch
      ? normalizeText(moneyMatch[0])
      : '';

    if (title && /\boff\b/i.test(title)) {
      title = title.replace(/\s+your\s+next\s+order$/i, '') + ' your next order';
    }

    if (!title) {
      var titleCandidates = Array.from(
        tile.querySelectorAll(
          'h1, h2, h3, h4, h5, h6, strong, b, [class*="title"], [class*="headline"]'
        )
      );

      var titleElement = titleCandidates.find(function (element) {
        var candidate = normalizeText(element.textContent);
        var lower = candidate.toLowerCase();

        return (
          candidate &&
          !lower.includes('redeem') &&
          !POINTS_PATTERN.test(candidate)
        );
      });

      title = titleElement
        ? normalizeText(titleElement.textContent)
        : '';
    }

    return {
      title: title,
      points: pointsMatch ? normalizeText(pointsMatch[0]) : '',
      button: button,
      tile: tile
    };
  }

  function collectRewards(root) {
    var buttons = Array.from(
      root.querySelectorAll('button, a')
    ).filter(function (button) {
      return normalizeText(button.textContent)
        .toLowerCase()
        .includes('redeem');
    });

    var seenTiles = new Set();

    return buttons.reduce(function (rewards, button) {
      var tile = findRewardTile(button, root);

      if (!tile || seenTiles.has(tile)) {
        return rewards;
      }

      seenTiles.add(tile);

      var reward = readRewardData(tile, button);

      if (reward.points) {
        rewards.push(reward);
      }

      return rewards;
    }, []);
  }

  function getBalance() {
    var rewardsWidget = findRewardsWidget();

    if (!rewardsWidget) {
      return '0';
    }

    var balanceElement = rewardsWidget.querySelector(
      '.yotpo-description-points-balance .yotpo-inner-text'
    );

    if (!balanceElement) {
      return '0';
    }

    var match = normalizeText(balanceElement.textContent).match(/\d[\d,]*/);

    return match ? match[0] : '0';
  }

  function createSection(rewards) {
    var section = document.getElementById(CONFIG.sectionId);

    if (!section) {
      section = document.createElement('section');
      section.id = CONFIG.sectionId;
    }

    section.innerHTML = `
      <div class="cw-redemption__inner">
        <div class="cw-redemption__header">
          <h2 class="cw-redemption__heading">${CONFIG.heading}</h2>
          <div class="cw-redemption__conversion">${CONFIG.conversionText}</div>
          <p class="cw-redemption__description">${CONFIG.description}</p>
        </div>

        <p class="cw-redemption__balance">
          You have <span class="cw-redemption__balance-value">${getBalance()}</span> points!
        </p>

        <div class="cw-redemption__cards"></div>
      </div>
    `;

    var cards = section.querySelector('.cw-redemption__cards');

    rewards.slice(0, 3).forEach(function (reward, index) {
      var card = document.createElement('article');
      card.className = 'cw-redemption__card';

      card.innerHTML = `
        <div class="cw-redemption__icon" aria-hidden="true">
          ${CONFIG.icons[index] || CONFIG.icons[0]}
        </div>

        <h3 class="cw-redemption__title">
          ${reward.title || 'Reward'}
        </h3>

        <div class="cw-redemption__points">
          ${reward.points}
        </div>

        <div class="cw-redemption__action"></div>
      `;

      var action = card.querySelector('.cw-redemption__action');

      reward.button.classList.add('cw-redemption__button');

      var buttonLabel = reward.button.querySelector(
        '.yotpo-button-label, [class*="button-label"], span'
      );

      if (buttonLabel) {
        buttonLabel.textContent = 'REDEEM MY POINTS';
      } else {
        reward.button.textContent = 'REDEEM MY POINTS';
      }

      action.appendChild(reward.button);
      cards.appendChild(card);
    });

    return section;
  }

  function insertSection(section, redemptionInstance) {
    var loyaltyPage =
      document.querySelector('.yotpo-widget-loyalty-page') ||
      document.querySelector('.yotpo-loyalty-page-container');

    var campaignInstance = document.querySelector(
      '.yotpo-widget-instance-container:has(.yotpo-widget-campaign-widget)'
    );

    if (campaignInstance && campaignInstance.parentNode) {
      campaignInstance.insertAdjacentElement('afterend', section);
      return;
    }

    if (redemptionInstance && redemptionInstance.parentNode) {
      redemptionInstance.parentNode.insertBefore(
        section,
        redemptionInstance.nextSibling
      );
      return;
    }

    if (loyaltyPage) {
      loyaltyPage.appendChild(section);
    }
  }

  function buildLoggedOutSection() {
    var loggedOutRewards = [
      { title: '$5 off your next order', points: '100 points', button: document.createElement('a') },
      { title: '$10 off your next order', points: '200 points', button: document.createElement('a') },
      { title: '$15 off your next order', points: '300 points', button: document.createElement('a') }
    ];

    loggedOutRewards.forEach(function (reward) {
      reward.button.href = '/account/login';
      reward.button.textContent = 'REDEEM MY POINTS';
    });

    var loggedOutSection = createSection(loggedOutRewards);
    loggedOutSection.classList.add('cw-redemption--logged-out');

    var balance = loggedOutSection.querySelector('.cw-redemption__balance');

    if (balance) {
      balance.remove();
    }

    loggedOutSection.querySelectorAll('.cw-redemption__action').forEach(function (action) {
      action.remove();
    });

    var loggedOutCta = document.createElement('a');
    loggedOutCta.className = 'cw-redemption__logged-out-cta';
    loggedOutCta.href = '/account/login';
    loggedOutCta.textContent = 'REDEEM MY POINTS';

    loggedOutSection
      .querySelector('.cw-redemption__inner')
      .appendChild(loggedOutCta);

    return loggedOutSection;
  }

  function render() {
    injectStyles();

    if (!isCustomerLoggedIn()) {
      insertSection(buildLoggedOutSection(), null);
      return true;
    }

    var redemptionSource = findRedemptionSource();

    if (!redemptionSource) {
      return false;
    }

    var rewards = collectRewards(redemptionSource.root);

    if (!rewards.length) {
      return false;
    }

    var section = createSection(rewards);

    /*
      createSection() reuses the same #cw-yotpo-redemption-rendered element
      across renders. If an earlier pass rendered the logged-out placeholder
      (e.g. before Yotpo's auth state resolved) it left the
      "cw-redemption--logged-out" class behind, which would otherwise leak
      logged-out styling into these real, logged-in cards.
    */
    section.classList.remove('cw-redemption--logged-out');

    insertSection(section, redemptionSource.instance);

    /*
      Hide only the exact native redemption block.
      Never hide the whole Yotpo instance because it may also contain
      the rewards guide/cards or other widgets.
    */
    redemptionSource.root.classList.add(
      'cw-yotpo-redemption-source-hidden'
    );

    return true;
  }

  function scheduleRender() {
    if (updateQueued) {
      return;
    }

    updateQueued = true;

    window.requestAnimationFrame(function () {
      updateQueued = false;
      render();
    });
  }

  function init() {
    var attempts = 0;
    var maxAttempts = 120;

    var interval = window.setInterval(function () {
      attempts += 1;

      if (render() || attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 250);

    observer = new MutationObserver(scheduleRender);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener('load', scheduleRender);
  }

  if (!isRewardsPage()) {
    return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


/* =========================================================================
 * SCRIPT 3 — Hide the "Sima Insiders" hero CTA buttons once logged in
 * ========================================================================= */
(function () {
  var BUTTONS_SELECTOR = '.sima-insiders-hero__buttons';

  function isVisible(element) {
    if (!element) {
      return false;
    }

    var styles = window.getComputedStyle(element);

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      styles.opacity !== '0' &&
      element.getClientRects().length > 0
    );
  }

  function isCustomerLoggedIn() {
    var loggedInView = document.querySelector(
      '.yotpo-widget-my-rewards-widget .yotpo-logged-in-view'
    );

    var pointsBalance = document.querySelector(
      '.yotpo-description-points-balance .yotpo-inner-text'
    );

    var loggedInButtons = document.querySelector(
      '.yotpo-action-buttons-tile .yotpo-primary-button'
    );

    return (
      isVisible(loggedInView) ||
      !!pointsBalance ||
      !!loggedInButtons
    );
  }

  function updateHeroButtonsVisibility() {
    var buttons = document.querySelector(BUTTONS_SELECTOR);

    if (!buttons) {
      return;
    }

    if (isCustomerLoggedIn()) {
      buttons.style.setProperty('display', 'none', 'important');
    } else {
      buttons.style.removeProperty('display');
    }
  }

  updateHeroButtonsVisibility();

  var observer = new MutationObserver(function () {
    updateHeroButtonsVisibility();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  window.addEventListener('load', updateHeroButtonsVisibility);
})();


/* =========================================================================
 * YOTPO REFERRAL — Figma-matched referral section
 * ========================================================================= */
(function () {
  var allowedPath = '/pages/rewards';
  var currentPath = window.location.pathname.replace(/\/$/, '');

  if (currentPath !== allowedPath) return;

  var CONFIG = {
    styleId: 'cw-yotpo-referral-figma-css',
    readyClass: 'cw-yotpo-referral-figma-ready',
    widgetSelector: '.yotpo-widget-referral-share',
    imageUrl: 'https://cdn.shopify.com/s/files/1/0021/7802/3536/files/315b80145341cca3c8382a9f72047e9df1c0fd7f.jpg?v=1780596427',
    reviewText: 'Loved by 50,000+ Happy Customers',
    heading: 'Give $10, Get 200 Points.',
    description: 'Share your link and your friend gets $10 off their first purchase of $40 minimum, and get 200 points for each successful referral.',
    namePlaceholder: 'Your First Name',
    emailPlaceholder: 'Your Email Address',
    buttonText: 'SEND INVITE',
    disclaimer: 'Offer only valid for new customers. Expires in 30 days. Must be a Sima Rewards member in order to refer.',
    shareHeading: 'More ways to share',
    emailLabel: 'Email',
    whatsappLabel: 'WhatsApp',
    emailSubject: "Discount to a Store You'll Love!",
    fallbackLinkText: 'Your referral link will appear here'
  };

  var initialized = false;
  var attempts = 0;
  var maxAttempts = 160;
  var observer = null;

  function injectStyles() {
    if (document.getElementById(CONFIG.styleId)) return;

    var style = document.createElement('style');
    style.id = CONFIG.styleId;
    style.textContent = `
      .${CONFIG.readyClass},
      .${CONFIG.readyClass} * {
        box-sizing: border-box;
      }

      .${CONFIG.readyClass} {
        width: 100%;
        margin: 0 auto;
        padding: clamp(28px, 3.2vw, 48px) clamp(18px, 2.55vw, 38px) clamp(48px, 5.15vw, 77px);
        background: #FFFFFF;
        display: flex;
        justify-content: center;
      }

      .cw-yotpo-referral-source,
      .${CONFIG.readyClass} .yotpo-widget-referral-share {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        margin: -1px !important;
        padding: 0 !important;
        overflow: hidden !important;
        clip: rect(0 0 0 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }

      section.shopify-section:has(.yotpo-widget-referral-share):not(.${CONFIG.readyClass}),
      .cw-yotpo-referral-pending {
        display: none !important;
      }

      .cw-yotpo-referral-figma {
        width: 100%;
        max-width: 1416px;
        min-height: 800px;
        height: auto;
        padding-right: clamp(36px, 6.7vw, 100px);
        background: #09152B;
        border-radius: 12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: clamp(32px, 5.35vw, 80px);
        overflow: hidden;
      }

      .cw-yotpo-referral-figma__media {
        width: min(47.82%, 677px);
        max-width: 677px;
        min-width: 0;
        height: 800px;
        flex: 0 1 677px;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        overflow: hidden;
      }

      .cw-yotpo-referral-figma__media img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
        object-position: center;
      }

      .cw-yotpo-referral-figma__content {
        width: auto;
        max-width: 559px;
        min-width: 0;
        flex: 1 1 559px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 32px;
      }

      .cw-yotpo-referral-figma__copy {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 24px;
      }

      .cw-yotpo-referral-figma__review {
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        gap: 12px;
      }

      .cw-yotpo-referral-figma__stars {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 2px;
        color: #F9CA22;
        font-size: 16px;
        line-height: 16px;
        letter-spacing: 0;
        white-space: nowrap;
      }

      .cw-yotpo-referral-figma__review-text {
        color: #FFFFFF;
        font-family: "Open Sans", sans-serif;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        white-space: nowrap;
      }

      .cw-yotpo-referral-figma__heading {
        width: 100%;
        margin: 0;
        color: #FFFFFF;
        font-family: Montserrat, sans-serif;
        font-size: clamp(32px, 2.8vw, 42px);
        font-weight: 600;
        line-height: 1.4;
        text-transform: capitalize;
      }

      .cw-yotpo-referral-figma__description {
        width: 100%;
        margin: 0;
        color: #FFFFFF;
        font-family: "Open Sans", sans-serif;
        font-size: clamp(16px, 1.2vw, 18px);
        font-weight: 400;
        line-height: 1.4;
      }

      .cw-yotpo-referral-figma__form {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 16px;
      }

      .cw-yotpo-referral-figma__input {
        width: 100%;
        height: 60px;
        padding: 11.99px 15.99px;
        background: #FFFFFF;
        border: 1px solid rgba(255, 255, 255, 0.31);
        border-radius: 3px;
        outline: 0;
        box-shadow: none;
        color: #181F2E;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 19.6px;
      }

      .cw-yotpo-referral-figma__input::placeholder {
        color: rgba(24, 31, 46, 0.50);
        opacity: 1;
      }

      .cw-yotpo-referral-figma__input[aria-invalid="true"] {
        outline: 2px solid #D14343;
        outline-offset: -2px;
      }

      .cw-yotpo-referral-figma__send {
        width: 100%;
        height: 60px;
        padding: 0 34px;
        border: 0;
        border-radius: 3px;
        background: #ECC643;
        color: #181F2E;
        font-family: Montserrat, sans-serif;
        font-size: 16px;
        font-weight: 600;
        line-height: 22.4px;
        text-align: center;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }

      .cw-yotpo-referral-figma__disclaimer {
        width: 100%;
        margin: 0;
        color: #FFFFFF;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 19.6px;
        text-align: center;
      }

      .cw-yotpo-referral-figma__link-row {
        width: 100%;
        height: 40px;
        padding: 11.99px 15.99px;
        border: 1px solid #FFFFFF;
        border-radius: 3px;
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        overflow: hidden;
        cursor: pointer;
        background: transparent;
      }

      .cw-yotpo-referral-figma__link-text {
        min-width: 0;
        flex: 1 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #FFFFFF;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 22.4px;
        text-align: left;
      }

      .cw-yotpo-referral-figma__copy-icon {
        width: 24px;
        height: 24px;
        flex: 0 0 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFFFFF;
      }

      .cw-yotpo-referral-figma__share-heading {
        width: 100%;
        margin: 0;
        color: #FFFFFF;
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        font-weight: 700;
        line-height: 25.2px;
      }

      .cw-yotpo-referral-figma__share-buttons {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 16px;
      }

      .cw-yotpo-referral-figma__share-button {
        height: 52px;
        padding: 11.99px 15.99px;
        border: 1px solid #FFFFFF;
        border-radius: 3px;
        background: transparent;
        color: #FFFFFF;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        font-weight: 400;
        line-height: 22.4px;
        cursor: pointer;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 12px;
      }

      .cw-yotpo-referral-figma__share-button--email {
        width: 274px;
      }

      .cw-yotpo-referral-figma__share-button--whatsapp {
        width: 269px;
      }

      .cw-yotpo-referral-figma--fallback .cw-yotpo-referral-figma__input,
      .cw-yotpo-referral-figma--fallback .cw-yotpo-referral-figma__send,
      .cw-yotpo-referral-figma--fallback .cw-yotpo-referral-figma__link-row,
      .cw-yotpo-referral-figma--fallback .cw-yotpo-referral-figma__share-button {
        opacity: 1 !important;
        cursor: pointer !important;
      }

      .cw-yotpo-referral-figma--fallback .cw-yotpo-referral-figma__input {
        color: rgba(24, 31, 46, 0.5);
      }

      .cw-yotpo-referral-figma__login-message {
        width: 100%;
        margin: -4px 0 0;
        color: #FFFFFF;
        font-family: "Open Sans", sans-serif;
        font-size: 13px;
        line-height: 18.2px;
        text-align: center;
        display: none;
      }

      .cw-yotpo-referral-figma__login-message.is-visible {
        display: block;
      }

      .cw-yotpo-referral-figma__share-icon {
        width: 24px;
        height: 24px;
        flex: 0 0 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: currentColor;
      }

      .cw-yotpo-referral-figma__share-icon svg,
      .cw-yotpo-referral-figma__copy-icon svg {
        width: 24px;
        height: 24px;
        display: block;
      }

      @media screen and (max-width: 749px) {
        .${CONFIG.readyClass} {
          width: 100%;
          max-width: 390px;
          margin: 0 auto;
          padding: 20px 13px;
        }

        .cw-yotpo-referral-figma {
          width: 100%;
          max-width: 363px;
          height: auto;
          padding: 0 20px 45px;
          border-radius: 12px;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          gap: 35px;
          overflow: hidden;
        }

        .cw-yotpo-referral-figma__media {
          width: calc(100% + 40px);
          max-width: none;
          height: min(329px, 90vw);
          flex: 0 0 329px;
          margin: 0 -20px;
          border-top-left-radius: 12px;
          border-top-right-radius: 12px;
          border-bottom-left-radius: 0;
        }

        .cw-yotpo-referral-figma__content {
          width: 100%;
          max-width: 317px;
          gap: 20px;
        }

        .cw-yotpo-referral-figma__copy {
          gap: 20px;
        }

        .cw-yotpo-referral-figma__review {
          gap: 12px;
        }

        .cw-yotpo-referral-figma__stars {
          width: 82px;
          height: 15px;
          flex: 0 0 82px;
          font-size: 16px;
          line-height: 15px;
        }

        .cw-yotpo-referral-figma__review-text {
          min-width: 0;
          font-size: clamp(10.5px, 3.05vw, 12px);
          line-height: 16.8px;
          white-space: normal;
        }

        .cw-yotpo-referral-figma__heading {
          font-size: 24px;
          line-height: 33.6px;
        }

        .cw-yotpo-referral-figma__description {
          font-size: 16px;
          line-height: 22.4px;
        }

        .cw-yotpo-referral-figma__input,
        .cw-yotpo-referral-figma__send {
          height: 52px;
        }

        .cw-yotpo-referral-figma__input {
          font-size: 12px;
          line-height: 16.8px;
        }

        .cw-yotpo-referral-figma__send {
          font-size: 16px;
          line-height: 22.4px;
        }

        .cw-yotpo-referral-figma__disclaimer {
          font-size: 12px;
          line-height: 16.8px;
        }

        .cw-yotpo-referral-figma__link-row {
          height: 40px;
        }

        .cw-yotpo-referral-figma__share-heading {
          font-size: 18px;
          line-height: 25.2px;
        }

        .cw-yotpo-referral-figma__share-buttons {
          gap: 16px;
        }

        .cw-yotpo-referral-figma__share-button {
          width: calc((100% - 16px) / 2);
          min-width: 0;
          height: 40px;
          padding: 7px 15.99px;
          font-size: 16px;
          line-height: 22.4px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function getWidget() {
    return document.querySelector(CONFIG.widgetSelector);
  }

  function getReferralLink(widget) {
    if (!widget) return '';

    var linkText = widget.querySelector('.yotpo-copy-text');
    var value = linkText ? normalizeText(linkText.textContent) : '';

    if (/^https?:\/\//i.test(value)) {
      return value;
    }

    var text = normalizeText(widget.textContent);
    var match = text.match(/https?:\/\/rwrd\.io\/[^\s]+/i);

    return match ? match[0] : '';
  }

  function getNativeCopyButton(widget) {
    if (!widget) return null;

    return widget.querySelector(
      '.yotpo-share-copy-link .yotpo-copy-text-button, .yotpo-main-copy-link, .yotpo-copy-text-button'
    );
  }

  function getNativeWhatsAppButton(widget) {
    if (!widget) return null;

    return widget.querySelector('.yotpo-whatsapp-share-button');
  }

  function copyText(value) {
    if (!value) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(value).catch(function () {});
      return;
    }

    var textarea = document.createElement('textarea');
    textarea.value = value;
    textarea.setAttribute('readonly', 'readonly');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
    } catch (error) {}

    document.body.removeChild(textarea);
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function buildEmailBody(referralLink) {
    return [
      "How does $10 off your first order at Sima sound?",
      '',
      "Use the link below and once you've shopped, I'll get a reward too.",
      '',
      referralLink
    ].join('\n');
  }

  function openPersonalEmail(recipient, referralLink) {
    var subject = CONFIG.emailSubject;
    var body = buildEmailBody(referralLink);
    var url =
      'mailto:' + encodeURIComponent(recipient) +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);

    window.location.href = url;
  }

  function getSection(widget) {
    if (!widget) return null;

    return widget.closest('section.shopify-section') || widget.parentElement;
  }

  function getContainer(section, widget) {
    if (!section) return null;

    return (
      section.querySelector('[class*="section-template--"][class*="-padding"]') ||
      widget.parentElement ||
      section
    );
  }

  function emailIcon() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M3 5.5h18v13H3v-13Z" fill="none" stroke="currentColor" stroke-width="1.6"/>
        <path d="m4.2 7 7.8 6 7.8-6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
  }

  function whatsappIcon() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 3.2a8.5 8.5 0 0 0-7.28 12.9L3.6 20.4l4.42-1.16A8.5 8.5 0 1 0 12 3.2Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
        <path d="M9.1 7.9c.18-.4.36-.4.62-.4h.52c.18 0 .36.04.46.3l.72 1.74c.08.2.04.38-.08.56l-.56.72c-.12.14-.12.3-.02.46.46.78 1.08 1.4 1.86 1.86.16.1.32.1.46-.02l.72-.56c.18-.12.36-.16.56-.08l1.74.72c.26.1.3.28.3.46v.52c0 .26 0 .44-.4.62-.44.2-1.42.38-2.8-.12-1.34-.48-2.5-1.3-3.48-2.28-.98-.98-1.8-2.14-2.28-3.48-.5-1.38-.32-2.36-.12-2.8Z" fill="currentColor"/>
      </svg>
    `;
  }

  function copyIcon() {
    return `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <rect x="8" y="7" width="11" height="13" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.6"/>
        <path d="M16 7V5.5A1.5 1.5 0 0 0 14.5 4h-9A1.5 1.5 0 0 0 4 5.5v11A1.5 1.5 0 0 0 5.5 18H8" fill="none" stroke="currentColor" stroke-width="1.6"/>
      </svg>
    `;
  }

  function createMarkup(referralLink, isFallback) {
    var wrapper = document.createElement('div');
    wrapper.className = 'cw-yotpo-referral-figma';

    if (isFallback) {
      wrapper.classList.add('cw-yotpo-referral-figma--fallback');
    }

    wrapper.innerHTML = `
      <div class="cw-yotpo-referral-figma__media">
        <img src="${CONFIG.imageUrl}" alt="">
      </div>

      <div class="cw-yotpo-referral-figma__content">
        <div class="cw-yotpo-referral-figma__copy">
          <div class="cw-yotpo-referral-figma__review">
            <div class="cw-yotpo-referral-figma__stars" aria-hidden="true">★★★★★</div>
            <div class="cw-yotpo-referral-figma__review-text">${CONFIG.reviewText}</div>
          </div>

          <h2 class="cw-yotpo-referral-figma__heading">${CONFIG.heading}</h2>
          <p class="cw-yotpo-referral-figma__description">${CONFIG.description}</p>
        </div>

        <div class="cw-yotpo-referral-figma__form">
          <input class="cw-yotpo-referral-figma__input cw-yotpo-referral-figma__name" type="text" placeholder="${CONFIG.namePlaceholder}" autocomplete="given-name">
          <input class="cw-yotpo-referral-figma__input cw-yotpo-referral-figma__email" type="email" placeholder="${CONFIG.emailPlaceholder}" autocomplete="email">
          <button class="cw-yotpo-referral-figma__send" type="button">${CONFIG.buttonText}</button>
          <p class="cw-yotpo-referral-figma__login-message" role="status" aria-live="polite">Please log in first to refer a friend.</p>
          <p class="cw-yotpo-referral-figma__disclaimer">${CONFIG.disclaimer}</p>
        </div>

        <button class="cw-yotpo-referral-figma__link-row" type="button" aria-label="Copy referral link">
          <span class="cw-yotpo-referral-figma__link-text">${referralLink}</span>
          <span class="cw-yotpo-referral-figma__copy-icon">${copyIcon()}</span>
        </button>

        <p class="cw-yotpo-referral-figma__share-heading">${CONFIG.shareHeading}</p>

        <div class="cw-yotpo-referral-figma__share-buttons">
          <button class="cw-yotpo-referral-figma__share-button cw-yotpo-referral-figma__share-button--email" type="button">
            <span class="cw-yotpo-referral-figma__share-icon">${emailIcon()}</span>
            <span>${CONFIG.emailLabel}</span>
          </button>
          <button class="cw-yotpo-referral-figma__share-button cw-yotpo-referral-figma__share-button--whatsapp" type="button">
            <span class="cw-yotpo-referral-figma__share-icon">${whatsappIcon()}</span>
            <span>${CONFIG.whatsappLabel}</span>
          </button>
        </div>
      </div>
    `;

    if (isFallback) {
      var fallbackInputs = wrapper.querySelectorAll('input');
      var loginMessage = wrapper.querySelector('.cw-yotpo-referral-figma__login-message');

      fallbackInputs.forEach(function (input) {
        input.readOnly = true;
        input.setAttribute('aria-disabled', 'true');
      });

      wrapper.querySelectorAll('button').forEach(function (button) {
        button.setAttribute('aria-disabled', 'true');
      });

      function showLoginMessage(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (loginMessage) {
          loginMessage.classList.add('is-visible');
        }
      }

      wrapper.addEventListener('click', function (event) {
        if (event.target.closest('input, button')) {
          showLoginMessage(event);
        }
      }, true);

      wrapper.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.closest('input, button')) {
          showLoginMessage(event);
        }
      }, true);
    }

    return wrapper;
  }

  function bindActions(wrapper, widget) {
    var emailInput = wrapper.querySelector('.cw-yotpo-referral-figma__email');
    var sendButton = wrapper.querySelector('.cw-yotpo-referral-figma__send');
    var copyButton = wrapper.querySelector('.cw-yotpo-referral-figma__link-row');
    var emailShareButton = wrapper.querySelector('.cw-yotpo-referral-figma__share-button--email');
    var whatsappShareButton = wrapper.querySelector('.cw-yotpo-referral-figma__share-button--whatsapp');

    function currentReferralLink() {
      return getReferralLink(widget) || normalizeText(
        wrapper.querySelector('.cw-yotpo-referral-figma__link-text').textContent
      );
    }

    function syncReferralLink() {
      var value = getReferralLink(widget);
      var target = wrapper.querySelector('.cw-yotpo-referral-figma__link-text');

      if (value && target && target.textContent !== value) {
        target.textContent = value;
      }
    }

    function shareEmail() {
      var email = emailInput ? emailInput.value.trim() : '';

      if (emailInput) {
        emailInput.setAttribute('aria-invalid', isValidEmail(email) ? 'false' : 'true');
      }

      if (!isValidEmail(email)) {
        if (emailInput) emailInput.focus();
        return;
      }

      openPersonalEmail(email, currentReferralLink());
    }

    sendButton.addEventListener('click', shareEmail);
    emailShareButton.addEventListener('click', shareEmail);

    if (emailInput) {
      emailInput.addEventListener('input', function () {
        emailInput.setAttribute('aria-invalid', 'false');
      });

      emailInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          shareEmail();
        }
      });
    }

    copyButton.addEventListener('click', function () {
      var nativeCopyButton = getNativeCopyButton(widget);
      var value = currentReferralLink();

      if (nativeCopyButton) {
        nativeCopyButton.click();
      } else {
        copyText(value);
      }
    });

    whatsappShareButton.addEventListener('click', function () {
      var nativeWhatsAppButton = getNativeWhatsAppButton(widget);

      if (nativeWhatsAppButton) {
        nativeWhatsAppButton.click();
        return;
      }

      var value = currentReferralLink();
      var message = 'I love Sima! Shop through my link to get a reward ' + value;
      window.open('https://wa.me/?text=' + encodeURIComponent(message), '_blank', 'noopener');
    });

    observer = new MutationObserver(syncReferralLink);
    observer.observe(widget, {
      childList: true,
      subtree: true,
      characterData: true
    });

    syncReferralLink();
  }

  function resetToHiddenState(section) {
    if (!section) return;

    section.classList.remove(CONFIG.readyClass);
    section.classList.add('cw-yotpo-referral-pending');

    var custom = section.querySelector('.cw-yotpo-referral-figma');

    if (custom) {
      custom.remove();
    }

    initialized = false;
  }

  function build(widget) {
    if (!widget) return false;

    injectStyles();

    var section = getSection(widget);

    if (!section) return false;

    widget.classList.add('cw-yotpo-referral-source');

    var isLoginScreen = !!widget.querySelector('.yotpo-screen-login');
    var isReferralScreen = !!widget.querySelector('.yotpo-screen-friends_emails');

    if (isLoginScreen) {
      var loginContainer = getContainer(section, widget);

      if (!loginContainer) return false;

      var loginFallback = section.querySelector('.cw-yotpo-referral-figma');

      if (!loginFallback || !loginFallback.classList.contains('cw-yotpo-referral-figma--fallback')) {
        if (loginFallback) loginFallback.remove();

        loginFallback = createMarkup(CONFIG.fallbackLinkText, true);
        loginContainer.appendChild(loginFallback);
      }

      section.classList.remove('cw-yotpo-referral-pending');
      section.classList.add(CONFIG.readyClass);

      initialized = true;
      return true;
    }

    section.classList.add('cw-yotpo-referral-pending');

    if (!isReferralScreen) return false;

    var referralLink = getReferralLink(widget);

    if (!referralLink) return false;

    var container = getContainer(section, widget);

    if (!container) return false;

    var custom = section.querySelector('.cw-yotpo-referral-figma');

    if (custom && custom.classList.contains('cw-yotpo-referral-figma--fallback')) {
      custom.remove();
      custom = null;
    }

    if (!custom) {
      custom = createMarkup(referralLink, false);
      container.appendChild(custom);
      bindActions(custom, widget);
    } else {
      var linkTarget = custom.querySelector('.cw-yotpo-referral-figma__link-text');

      if (linkTarget && linkTarget.textContent !== referralLink) {
        linkTarget.textContent = referralLink;
      }
    }

    section.classList.remove('cw-yotpo-referral-pending');
    section.classList.add(CONFIG.readyClass);

    initialized = true;
    return true;
  }

  var renderQueued = false;

  function scheduleBuild() {
    if (renderQueued) return;

    renderQueued = true;

    window.requestAnimationFrame(function () {
      renderQueued = false;
      build(getWidget());
    });
  }

  function init() {
    injectStyles();
    scheduleBuild();

    if (!observer) {
      observer = new MutationObserver(scheduleBuild);
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', scheduleBuild);
})();

/* =========================================================================
 * SECTION ORDER — Place points-worth table after redemption section
 * ========================================================================= */
(function () {
  function normalizeText(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function findPointsWorthSection() {
    var headings = Array.from(
      document.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]')
    );

    var heading = headings.find(function (element) {
      return normalizeText(element.textContent).includes(
        "here's exactly what your points are worth"
      );
    });

    if (!heading) return null;

    return heading.closest('section.shopify-section') || heading.closest('section');
  }

  function placeTableAfterRedemption() {
    var redemptionSection = document.getElementById('cw-yotpo-redemption-rendered');
    var tableSection = findPointsWorthSection();

    if (
      !redemptionSection ||
      !tableSection ||
      redemptionSection === tableSection ||
      !redemptionSection.parentNode
    ) {
      return false;
    }

    if (redemptionSection.nextElementSibling !== tableSection) {
      redemptionSection.parentNode.insertBefore(
        tableSection,
        redemptionSection.nextElementSibling
      );
    }

    return true;
  }

  function init() {
    var attempts = 0;
    var maxAttempts = 120;

    var interval = window.setInterval(function () {
      attempts += 1;

      if (placeTableAfterRedemption() || attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 250);

    var observer = new MutationObserver(function () {
      placeTableAfterRedemption();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('load', placeTableAfterRedemption);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* =========================================================================
 * MOBILE REFERRAL POSITION — Center card and add spacing after points table
 * ========================================================================= */
(function () {
  var STYLE_ID = 'cw-referral-mobile-position-fix';

  function injectStyle() {
    var oldStyle = document.getElementById(STYLE_ID);

    if (oldStyle) {
      oldStyle.remove();
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media screen and (max-width: 749px) {
        .cw-yotpo-referral-figma {
          width: min(363px, calc(100vw - 40px)) !important;
          max-width: calc(100vw - 40px) !important;
          margin-top: 45px !important;
          margin-right: 0 !important;
          margin-bottom: 0 !important;
          margin-left: 50% !important;
          position: relative !important;
          left: 0 !important;
          transform: translateX(-50%) !important;
          box-sizing: border-box !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectStyle);
  } else {
    injectStyle();
  }
})();

/* =========================================================================
 * LOGGED-OUT DUPLICATE STEPS — hide native Yotpo guide instance only
 * ========================================================================= */
(function () {
  var INSTANCE_SELECTOR = '.yotpo-widget-instance-container[yotpo-instance-id="1334566"]';

  function isLoggedOut() {
    return !!document.querySelector(
      '.yotpo-logged-out-customer, .yotpo-customer-logged-out-buttons, .yotpo-customer-logged-out-buttons-mobile'
    );
  }

  function updateDuplicateStepsVisibility() {
    var instance = document.querySelector(INSTANCE_SELECTOR);

    if (!instance) return;

    if (isLoggedOut()) {
      instance.style.setProperty('display', 'none', 'important');
    } else {
      instance.style.removeProperty('display');
    }
  }

  function init() {
    updateDuplicateStepsVisibility();

    var observer = new MutationObserver(updateDuplicateStepsVisibility);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    window.addEventListener('load', updateDuplicateStepsVisibility);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();